window.theme = window.theme || {};

if (console && console.log) {
  console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function($){
  var $ = jQuery = $;

  theme.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  theme.a11y = {
  
    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      /**
       * Get every possible visible focusable element
       */
      var $focusableElements = options.$container.find(
        $(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        ).filter(':visible')
      );
      var firstFocusable = $focusableElements[0];
      var lastFocusable = $focusableElements[$focusableElements.length - 1];
  
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
  
      function _manageFocus(evt) {
        // Tab key
        if (evt.keyCode !== 9) return;
  
        /**
         * On the last focusable element and tab forward,
         * focus the first element.
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
        /**
         * On the first focusable element and tab backward,
         * focus the last element.
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
  
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
  
      $(document).off('focusin');
  
      $(document).on(eventsName.focusout, function() {
        $(document).off(eventsName.keydown);
      });
  
      $(document).on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        $(document).on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
    },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    },
  
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
  
    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
  
      if (!container) {
        return;
      }
  
      this.createInstance(container);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      if (!subSection) {
        this._loadSubSections();
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
  
    _loadSubSections: function() {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },
  
    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    register: function(type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
  
      if ($scope) {
        $sections = $('[data-section-type=' + type + ']', $scope);
      }
  
      $sections.each(function(index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });
  
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    /**
     * Create lazyloading-friendly image string
     *
     * @param string
     * @returns string with _{width}x as size param
     */
    function lazyloadImagePath(string) {
      var image;
  
      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }
  
      return image;
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();
  
  theme.Variants = (function() {
  
    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
  
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
  
        return currentOptions;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }

(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', {variant: variant})));
},
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
  
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
  
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
  
    return Variants;
  })();
  
  theme.rte = {
    init: function() {
      theme.rte.wrapTable();
      theme.rte.wrapVideo();
      theme.rte.imageLinks();
    },
  
    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
  
    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
  
      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },
  
    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };
  

  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.$modal = $('#' + id);
  
      if (!this.$modal.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
  
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
  
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
  
      $('body')
        .trigger('productModalOpen')
        .trigger('modalOpen.' + this.id);
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      window.setTimeout(function() {
        this.nodes.$parent.removeClass(this.config.bodyClosingClass);
        this.$modal.removeClass(this.config.closingClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false').focus();
        }
      }.bind(this), 550); // modal close css transition
  
      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
  
      $('body').trigger('modalClose.' + this.id);
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
  
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.Drawers = (function() {
    function Drawer(id, name, ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    };
  
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);
  
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
  
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        $('body').on('productModalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
        } else if (returnFocusEl) {
          var $el = $(returnFocusEl);
          this.$activeSource = $el.attr('aria-expanded', 'true');
        }
  
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
  
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        $('body')
          .trigger('drawerOpen')
          .trigger('drawerOpen.' + this.config.id);
  
        this.bindEvents();
        updateCartDrawerBoldSavings();
      },
  
      close: function() {
        if (!this.isOpen) {
          return;
        }
  
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
  
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
  
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        window.setTimeout(function() {
          this.$nodes.parent.removeClass(this.config.closingClass);
          if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false').focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        if (!this.ignoreScrollLock) {
          theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
  
        // Clicking out of drawer closes it.
        // Check to see if clicked on element in drawer
        // because of any drawer built witin #MainContent
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);
          if (!doNotClose) {
            this.close();
            return false;
          }
  
        }.bind(this));
  
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
  
      unbindEvents: function() {
        if (!this.ignoreScrollLock) {
          theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },
  
      // Check if clicked element is inside the drawer
      elementInsideDrawer: function($el) {
        return this.$drawer.find($el).length;
      }
    });
  
    return Drawer;
  })();
  
  theme.cart = {
    getCart: function() {
      return $.getJSON(theme.routes.cart);
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartChange,
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
  
    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartAdd,
        data: data,
        dataType: 'json'
      });
    },
  
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this))
    },
  
    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };
  
      $.ajax(params);
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }
  
  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function() {
      $(this).addClass('btn--loading');
    });
  
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
  
  
    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  
    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });
  
  theme.QtySelector = (function() {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
      remove: '.js-qty__remove'
    };
  
    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);
      this.$plus = $el.find(classes.plus);
      this.$minus = $el.find(classes.minus);
      this.minValue = this.$input.attr('min') || 1;
      this.$remove = $el.find(classes.remove);
  
      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };
  
      this.options = $.extend(defaults, options);
  
      this.initEventListeners();
    };
  
    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      initEventListeners: function() {
        this.$remove.on('click', function() {
          var qty = 0;
          this.changeQty(qty);
        }.bind(this));

        this.$plus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));
  
        this.$minus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));
  
        this.$input.on('change', function() {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },
  
      addQty: function(number) {
        var qty = number + 1;
        this.changeQty(qty);
      },
  
      subtractQty: function(number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.changeQty(qty);
      },
  
      changeQty: function(qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
      },
  
      validateQty: function(number) {
        if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });
  
    return QtySelector;
  })();
  
  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };
  
    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble'
    };
  
    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };
  
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      // Prep handlebars template
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
  
      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));
  
      this.initEventListeners();
    };
  
    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
        $('body').on('added.ajaxProduct', function(evt, returnFocusEl, isCartOpen = true) {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, isCartOpen, returnFocusEl);
          }.bind(this));
        }.bind(this));
      },
  
      buildCart: function(cart, openDrawer, returnFocusEl) {
(typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.cartDoctor !== 'undefined' && (cart = window.BOLD.common.cartDoctor.fix(cart)));

        this.loading(true);
        this.emptyCart();
  
        if (cart.item_count === 0) {
          $(selectors.container).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p></div>');
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
          
          $.each(cart.items, function(index, product) {
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = 'null';
            }
  
            if (product.properties !== null) {
              $.each(product.properties, function(key, value) {
                if (key.charAt(0) === '_' || !value) {
                   delete product.properties[key];
                 }
              });
            }
  
            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;
  
                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
              }
            }
  
            animation_row+=2;
              item = {
                key: product.key,
                url: product.url,
                img: prodImg,
                animationRow: animation_row,
                name: product.product_title,
                variation: product.variant_title,
                properties: product.properties,
                itemQty: product.quantity,
                price: '<span class="money" data-line-index="' + index +  '">' + theme.Currency.formatMoney(product.price, theme.settings.moneyFormat) + '</span>',
                unitPrice: theme.Currency.formatMoney(product.unit_price, theme.settings.moneyFormat),
                unitBase: theme.Currency.getBaseUnit(product),
                discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
                discounts: product.line_level_discount_allocations,
                discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
                vendor: product.vendor
              };
              console.log(item);
              items.push(item);            
          });
  
          animation_row+=2;
  
          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
  
              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount,theme.settings.moneyFormat);
            }
          }
  
          data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
totalPrice: '<span class"money" data-cart-total>' + theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat) + '</span>'
};
  
          $(selectors.container).append(this.template(data));
        }
  
        this.status.loaded = true;
        this.loading(false);
  
        $('body').trigger('updateCart' + config.namespace, cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
  
        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (openDrawer === true) {
          this.drawer.open(false, returnFocusEl);
        }
        (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));

        let cartItemsWithTags = cart.items.map(item => {
          return this.getCartItemWithTags(item)
        });

        Promise.all(cartItemsWithTags).then(cartItemsWithTags => {
          let regpriceItemsNumber = 0;
          for(i = 0; i < cartItemsWithTags.length; i++) {
            if(cartItemsWithTags[i].tags.indexOf('regprice') > -1){
              regpriceItemsNumber += cartItemsWithTags[i].quantity;
            }
          }

          updateRegpriceProgressbar(regpriceItemsNumber);

          updatePdpPrice(cartItemsWithTags, regpriceItemsNumber);

          updateCartDrawerBoldSavings();

          cartItemsWithTags.forEach(item => {
            if(item.tags.indexOf('regprice') > -1){
              $(`.js-regprice-discount[data-id='${item.key}']`).addClass('show');
            }
            else if(item.tags.indexOf('netprice') > -1) {
              $(`.js-netprice-item[data-id='${item.key}']`).removeClass('hidden');
            }
          });
        });

},
      getCartItemWithTags: function (item) {
        return jQuery.getJSON(`/products/${item.handle}.js`).then(product => {
          item.tags = product.tags;
          return item;
        })
      },
  
      initQtySelectors: function() {
        $(selectors.container).find('.js-qty__ajax-cart-control-wrapper').each(function(index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
        }.bind(this));
  
        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },
  
      updateItem: function(evt, key, qty) {
        if (this.status.loading) {
          return;
        }
  
        this.loading(true);
  
        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            this.updateSuccess(cart);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.updateError(XMLHttpRequest)
            console.log('error')
          }.bind(this))
          .always(function() {
            this.loading(false);
          }.bind(this));
      },
  
      loading: function(state) {
        this.status.loading = state;
  
        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },
  
      emptyCart: function() {
        $(selectors.container).empty();
      },
  
      updateSuccess: function(cart) {
        this.buildCart(cart)
      },
  
      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          // console.warn(XMLHttpRequest.responseJSON.description);
        }
      },
  
      updateCartNotification: function(evt, cart) {
        if (cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
          var cartItemCount = $('.cart-link__bubble');
          cartItemCount.html(cart.item_count);
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      }
    });
  
    return CartDrawer;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');
      this.$addCase = this.$form.find('.btn-add-case')
  
      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };
	
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        var ua = navigator.userAgent.toLowerCase();
        if (!ua.indexOf('safari') != -1) { 
          let buttonClickedName = $(document.activeElement)[0].getAttribute('name');
        }
        evt.preventDefault();
        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button or on 'Add case' button
        if(buttonClickedName === 'add') {
          this.$addToCart.addClass('btn--loading');
          var data = this.$form.serialize();
        } else if (buttonClickedName === 'add-case') {
          this.$addCase.addClass('btn--loading');
          // Add case functionality. Change quantity
          let quantity = $('#variant-inventory').text();

          var data = this.$form.serializeArray();

          // Find and replace quantity 
          for (let index = 0; index < data.length; ++index) {
            if (data[index].name == "quantity") {
              data[index].value = parseInt(quantity)
              break;
            }
          }

          // Convert to URL-encoded string
          data = jQuery.param(data);

        } else {
          var data = this.$form.serialize();
        }

        status.loading = true;
  
        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.success(product);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
            this.$addCase.removeClass('btn--loading');
          }.bind(this));
      },
  
      success: function(product) {
        this.$form.find('.errors').remove();
        if($('.product-single__meta .product-label-warning').length){ // If pre-arrival label exist in product description on the page
          $('.modal-preorder').show();
          $('body').trigger('added.ajaxProduct', [this.$addToCart, false]); // Add product to cart and don't show slide-out cart untill '.modal-preorder .btn' will be clicked
        } else {
          $('body').trigger('added.ajaxProduct', this.$addToCart);
        }
      },
  
      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();
  
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });
  
    return ProductForm;
  })();
  
  theme.collapsibles = (function() {
  
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
  
      // Event listeners (hack for modals)
      $('body, .modal__inner')
        .off(namespace)
        .on('click' + namespace, selectors.trigger, function() {
  
        if (isTransitioning) {
          return;
        }
  
        isTransitioning = true;
  
        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);
  
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }
  
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
  
        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);
  
        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }
  
    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
  
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 350);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  theme.headerNav = (function() {
  
    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      megamenu: '.megamenu',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
      overlaidBodyClass: 'overlaid-header',
      stickyBodyClass: 'sticky-header'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyInitialized: false,
      forceStopSticky: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;
  
    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
  
      config.wrapperOverlayed = theme.settings.overlayHeader = $wrapper.hasClass(config.overlayedClass);
      config.stickyEnabled = $siteHeader.data('sticky');
  
      if (config.stickyEnabled) {
        stickyHeaderCheck();
        $window.on('resize' + config.namespace, $.debounce(150, stickyHeaderCheck));
      }
  
      if (config.wrapperOverlayed) {
        $('body').addClass(classes.overlaidBodyClass);
      }
  
      accessibleDropdowns();
      searchDrawer();
    }
  
    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }
  
    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
  
      $(selectors.closeSearch).on('click' + config.namespace, function() {
        closeSearchDrawer();
      });
    }
  
    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open--search');
  
      theme.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
  
      // Clicking out of container closes it
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
  
      $parent.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }
  
    function closeSearchDrawer() {
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      $parent.removeClass('js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
  
      theme.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
  
      theme.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
  
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
  
          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
  
        // tapping outside of the dropdown closes it
        $('body').on('touchend' + config.namespace, function() {
          closeSecondLevelDropdown();
          closeThirdLevelDropdown();
        });
  
        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        $(selectors.megamenu).on('touchend' + config.namespace, function(evt) {
          evt.stopImmediatePropagation();
        });
      }
  
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown($(this));
      });
  
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });
  
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openSecondLevelDropdown($(this), true);
      });
  
      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }
  
      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }
  
      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
  
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeaderSetup();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function stickyHeaderSetup() {
      if (!config.stickyInitialized) {
        $parent.addClass(classes.stickyBodyClass);
        $siteHeader.wrap('<div class="site-header-sticky"></div>');
  
        stickyHeaderHeight();
        setTimeout(function() {
          stickyHeaderHeight();
        }, 200);
  
        $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
        $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
      }
  
      config.stickyInitialized = true;
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      $(selectors.megamenu).each(function() {
        var h = $(this).outerHeight();
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 100)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeaderHeight() {
      var height = $siteHeader.outerHeight(true);
      var $stickyHeader = $('.site-header-sticky').css('height', height);
  
      // Also update top position of sticky sidebar
      if ($('.grid__item--sidebar').length) {
        $('.grid__item--sidebar').css('top', height + 10);
      }
    }
  
    function stickyHeaderScroll() {
      if (config.forceStopSticky) {
        return;
      }
  
      var scroll = $window.scrollTop();
      var threshold = 150;
  
      if (scroll > threshold) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;
  
        $siteHeader.addClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          $siteHeader.addClass(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.addClass(config.overlayedClass);
        }
      }
  
      config.lastScroll = scroll;
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(config.stickyEnabledClass)
        .removeClass(config.overlayedClass);
  
      $('body').removeClass(classes.overlaidBodyClass);
      config.wrapperOverlayed = false;
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      unload: unload
    };
  })();
  
  theme.Slideshow = (function() {
    this.$slideshow = null;
  
    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };
  
    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
  
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: args.autoplay ? true : false,
        autoplaySpeed: this.$slideshow.data('speed')
      };
  
      this.$slideshow.off('beforeChange');
      this.$slideshow.off('afterSlideChange');
      this.$slideshow.on('init', this.init.bind(this));
      this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
      this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));
  
      this.$slideshow.slick(this.settings);
  
      this.$pause.on('click', this._togglePause.bind(this));
    }
  
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
  
        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function(event, slick, currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },
  
      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
  
      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
  
      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
  
        if (!$list) {
          return;
        }
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
  
        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
  
      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;
  
        $slideshow.find('.slick-slide').each(function(index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
  
            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');
  
              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
  
            }, this.settings.autoplaySpeed / 1.5);
  
          }
        }.bind(this));
      }
    });
  
    return slideshow;
  })();
  
  theme.announcementBar = (function() {
    var slideCount = 0;
    var compact = false;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      touchThreshold: 20,
      slidesToShow: 1
    };
    var $slider;
  
    function init() {
      $slider = $('#AnnouncementSlider');
      if (!$slider.length) {
        return;
      }
  
      slideCount = $slider.data('block-count');
      compact = $slider.data('compact-style');
  
      var desktopOptions = $.extend({}, defaults, {
        slidesToShow: compact ? 1 : slideCount,
        slidesToScroll: 1
      });
  
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1
      });
  
      if (theme.config.bpSmall) {
        initSlider($slider, mobileOptions);
      } else {
        initSlider($slider, desktopOptions);
      }
  
      $('body').on('matchSmall', function() {
        initSlider($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        initSlider($slider, desktopOptions);
      }.bind(this));
    }
  
    function initSlider($slider, args) {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
      $slider.slick(args);
    }
  
    function isInitialized($slider) {
      return $slider.length && $slider.hasClass('slick-initialized');
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var $slide = $('#AnnouncementSlide-' + id);
      if ($slider.length) {
        $slider.slick('slickPause');
      }
      if ($slide.length) {
        $slider.slick('slickGoTo', $slide.data('index'));
      }
    }
  
    function onBlockDeselect(id) {
      if ($slider.length && isInitialized($slider)) {
        $slider.slick('slickPlay');
      }
    }
  
    function unload() {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.predictiveSearch = (function() {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
  
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '.predictive-results',
  
      searchButton: '[data-predictive-search-button]',
  
      resultDiv: '#PredictiveResults',
      resultTemplate: '#PredictiveTemplate'
    };
  
    var classes = {
      isActive: 'predicitive-active'
    };
  
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };
  
    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
  
      $(selectors.form).attr('autocomplete', 'off');
      $(selectors.form).on('submit' + namespace, submitSearch);
  
      $(selectors.input, selectors.form).on('keyup' + namespace, handleKeyup);
      $(selectors.searchButton, selectors.wrapper).on('click' + namespace, triggerSearch);
  
      // Prep handlebars template
      var source = $(selectors.resultTemplate).html();
      resultTemplate = Handlebars.compile(source);
    }
  
    function reset() {
      $(selectors.wrapper).addClass('hide');
      clearTimeout(searchTimeout);
    }
  
    function triggerSearch() {
      $(selectors.form).trigger('submit');
    }
  
    // Append * wildcard to search
    function submitSearch(evt) {
      var $form = $(this);
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
  
      var data = $form.serializeArray().reduce(function(obj, item) {
        obj[item.name] = item.value;
        return obj;
      }, {});
  
      if (data.q) {
        data.q += '*';
      }
  
      var query = $.param(data);
  
      window.location.href = '/search?' + query;
      return false;
    }
  
    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        navigationEvent(evt, 'up');
        return;
      }
  
      if (evt.keyCode === keys.down_arrow) {
        navigationEvent(evt, 'down');
        return;
      }
  
      if (evt.keyCode === keys.tab) {
        return;
      }
  
      search();
    }
  
    function search() {
      var keyword = $(selectors.input, selectors.form).val();
  
      if (keyword === '') {
        reset();
        return;
      }
  
      var q = _normalizeQuery(keyword);
  
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }
  
    function predictQuery(q) {
      if (isLoading) {
        return;
      }
  
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
  
      currentString = q;
      isLoading = true;
  
      jQuery.getJSON('/search/suggest.json', {
        "q": q,
        "resources": {
          "type": theme.settings.predictiveSearchType,
          "limit": 4,
          "options": {
            "unavailable_products": "last",
            "fields": "title,product_type,variants.title,vendor"
          }
        }
      }).done(function(response) {
        isLoading = false;
        var data = {};
        var resultCount = 0;
  
        $(selectors.wrapper).removeClass('hide');
  
        var resultTypes = Object.entries(response.resources.results);
  
        for (var i = resultTypes.length - 1; i >= 0; i--) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;
  
          switch(type) {
            case 'products':
              data[type] = buildProducts(results);
              break;
            case 'collections':
              data[type] = buildCollections(results);
              break;
            default:
              data[type] = parseResultImages(results);
              break;
          }
        }
  
        if (resultCount === 0) {
          reset();
        }
  
        // Append result markup
        $(selectors.resultDiv).empty().append(resultTemplate(data));
      });
    }
  
    function buildProducts(results) {
      var products = [];
  
      for (var i = results.length - 1; i >= 0; i--) {
        var product = results[i];
  
        var new_product = {
          title: product.title,
          url: product.url,
          image: theme.Images.lazyloadImagePath(product.image),
          vendor: product.vendor,
          price: theme.Currency.formatMoney(product.price),
          compare_price_max: theme.Currency.formatMoney(product.compare_at_price_max),
          on_sale: parseInt(product.compare_at_price_max) > parseInt(product.price),
          custom_label: _checkCustomLabel(product.tags)
        };
  
        products.push(new_product);
      }
  
      return products;
    }
  
    function buildCollections(results) {
      var collections = [];
  
      for (var i = results.length - 1; i >= 0; i--) {
        var collection = results[i];
  
        var new_collection = {
          title: collection.title,
          url: collection.url
        };
  
        collections.push(new_collection);
      }
  
      return collections;
    }
  
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function parseResultImages(results) {
      for (var i = results.length - 1; i >= 0; i--) {
        if (!results[i].image) {
          continue;
        }
  
        var image = theme.Images.lazyloadImagePath(results[i].image);
        results[i].image = image;
      }
  
      return results;
    }
  
    function _checkCustomLabel(tags) {
      if (!tags.length) {
        return false;
      }
  
      for (var i = tags.length - 1; i >= 0; i--) {
        if (tags[i].indexOf('_label_') !== -1) {
          return tags[i].replace('_label_', '');
        }
      }
  
      return false;
    }
  
    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
  
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }
  
    function navigationEvent(evt, direction) {
  
    }
  
    return {
      init: init
    };
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var $buttons = $('.quick-product__btn');
  
    $buttons.each(function() {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;
  
      // If another identical modal exists, remove duplicates
      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }
  
      new theme.Modals(modalId, name);
      ids.push(id);
    });
  };
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onPlayerReady
      }
    };
  
    var videoHolderId = 'VideoHolder';
    var activeVideo = false;
  
    var selectors = {
      videoHolder: '#' + videoHolderId,
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    if (!$(selectors.youtube).length && !$(selectors.mp4Trigger).length) {
      return;
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    $(selectors.youtube).on('click', triggerYouTubeModal);
    $(selectors.mp4Trigger).on('click', triggerMp4Modal);
  
    // Handle closing video modal
    $('body').on('modalClose.VideoModal', function() {
      // Slight timeout so YouTube player is destroyed after the modal closes
      if (youtubePlayer && activeVideo === 'youtube') {
        setTimeout(function() {
          youtubePlayer.destroy();
        }, 500); // modal close css transition
      } else {
        emptyVideoHolder();
      }
    });
  
    function triggerYouTubeModal(evt) {
      emptyVideoHolder();
  
      evt.preventDefault();
      theme.LibraryLoader.load('youtubeSdk');
  
      if (theme.config.youTubeReady) {
        startYoutubeOnClick(evt);
      } else {
        $('body').on('youTubeReady', function() {
          startYoutubeOnClick(evt);
        });
      }
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var $el = $(evt.currentTarget);
      var $mp4Player = $el.next(selectors.mp4Player);
  
      $mp4Player.clone().removeClass('hide').appendTo(selectors.videoHolder);
  
      modal.open(evt);
  
      // Play new video element
      $(selectors.videoHolder).find('video')[0].play();
  
      activeVideo = 'mp4';
    }
  
    function startYoutubeOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));
  
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
  
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
  
      youtubePlayer = new YT.Player(videoHolderId, args);
      modal.open(evt);
  
      activeVideo = 'youtube';
    }
  
    function onPlayerReady(evt) {
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      $(selectors.videoHolder).empty();
    }
  };
  
  theme.RecentlyViewed = (function() {
    var selectors = {
      template: '#RecentlyViewedProduct',
      outputContainer: '#RecentlyViewed-'
    };
  
    var init = false;
  
    function RecentlyViewed(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.namespace = '.recently-viewed' + sectionId;
  
      if (!$(selectors.template).length) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
    };
  
    RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if ($.isEmptyObject(theme.recentlyViewed.recent)) {
          // No previous history on page load, so bail
          return;
        }
  
        this.outputContainer = $(selectors.outputContainer + this.sectionId);
        this.handle = this.$container.attr('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        for (handle in theme.recentlyViewed.recent) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this), function(error) {
          console.warn('Theme | recently viewed products failed to load');
        });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.init();
          $(window).off('scroll' + this.namespace);
        }
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            jQuery.getJSON('/products/'+ handle +'.js', function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.$container.attr('data-recent-count');
  
        var i = 0;
        for (key in products) {
          var product = products[key];

    (typeof window.BOLD !== 'undefined' && typeof window.BOLD.pre !== 'undefined' && typeof BOLD.pre.addProductJson !== 'undefined' && BOLD.pre.addProductJson({id: product.id, variants: product.variants }));
// Ignore current product
          if (product.handle === this.handle) {
            continue;
          }
  
          i++;
  
          // New or formatted properties
          product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
          product.on_sale = product.compare_at_price > product.price;
          product.sold_out = !product.available;product.price_formatted = '<span class="money" data-product-id="' + product.id + '">' + theme.Currency.formatMoney(product.price, theme.settings.moneyFormat) + '</span>';product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
          product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
          product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
          product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
          product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);
  
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }
  
        data = {
          items: allProducts.slice(0, limit),
          grid_item_width: this.$container.attr('data-grid-item-class')
        };
  
        if (allProducts.length === 0) {
          return;
        }
  
        // Prep handlebars template
        var source = $(selectors.template).html();
        var template = Handlebars.compile(source);
        this.outputContainer.append(template(data));
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        init = false;
        $('window').off(this.namespace);
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 7; // higher is slower
  
    function parallax(el, args) {
      this.$container = $(el);
      this.namespace = args.namespace;
  
      if (!this.$container.length) {
        return;
      }
  
      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container, args)
      }
    }
  
    parallax.prototype = $.extend({}, parallax.prototype, {
      init: function(desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;
  
        $window.on('scroll' + this.namespace, function(evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));
  
        // Reinit on resize
        $window.on('resize' + this.namespace, $.debounce(350, function() {
          $window.off(this.namespace);
  
          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }
  
          this.init();
        }.bind(this)));
      },
  
      desktopInit: function() {
        if (!theme.config.bpSmall) {
          this.init(true);
        }
  
        $('body').on('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        $('body').on('matchLarge', function() {
          this.init(true);
        }.bind(this));
      },
  
      destroy: function() {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });
  
    return parallax;
  })();
  
  // Select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }
  
    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions)
        };
      },
  
      _connectToggle: function() {
        this.cache.$disclosureToggle.on(
          'click',
          function(evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr('aria-expanded') === 'true';
            $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
  
            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },
  
      _connectOptions: function() {
        this.cache.$disclosureOptions.on(
          'click',
          function(evt) {
            evt.preventDefault();
            this._submitForm($(evt.currentTarget).data('value'));
          }.bind(this)
        );
      },
  
      _onFocusOut: function() {
        this.cache.$disclosureToggle.on(
          'focusout',
          function(evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;
  
            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );
  
        this.cache.$disclosureList.on(
          'focusout',
          function(evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
  
            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );
  
        this.$container.on(
          'keyup',
          function(evt) {
            if (evt.which !== 27) return;
            this._hideList();
            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );
  
        $('body').on(
          'click',
          function(evt) {
            var isOption = this.$container.has(evt.target).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
  
            if (isVisible && !isOption) {
              this._hideList();
            }
          }.bind(this)
        );
      },
  
      _submitForm: function(value) {
        $('body').addClass('unloading');
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },
  
      _hideList: function() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },
  
      unload: function() {
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      }
    });
  
    return Disclosure;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.each(function(index) {
        var $modelViewerContainer = $(this);
        var mediaId = $modelViewerContainer.data('media-id');
        var $modelViewerElement = $(
          $modelViewerContainer.find('model-viewer')[0]
        );
        var modelId = $modelViewerElement.data('model-id');
  
        if (index === 0) {
          var $xrButton = $modelViewerContainer
            .closest(selectors.mediaGroup)
            .find(selectors.xrButton);
          xrButtons[sectionId] = {
            $element: $xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          $container: $modelViewerContainer,
          $element: $modelViewerElement
        };
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
          var $modelJson = $('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
      model.$container.on('mediaVisible', function() {
        xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.$container
        .on('mediaHidden', function() {
          xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
          model.modelViewerUi.pause();
        })
        .on('xrLaunch', function() {
          model.modelViewerUi.pause();
        });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  

  theme.collectionTemplate = (function() {
    var isAnimating = false;
  
    var selectors = {
      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list a',
      filters: '.collection-filter'
    };
  
    var settings = {
      combineTags: $(selectors.sidebar).data('combine-tags')
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove'
    };
  
    function init() {
      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {
          getNewCollectionContent(location.href);
        }
      });
  
      // Set mobile top value for filters if sticky header enabled
      if (theme.config.stickyHeader) {
        setFilterStickyPosition();
        $(window).on('resize', $.debounce(150, setFilterStickyPosition));
      }
  
      initTagClicks();
    }
  
    function initTagClicks() {
      $('body').on('click', selectors.tags, function(evt) {
        var $el = $(this);
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        if ($el.hasClass('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr('href');
  
        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);
  
            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if ($el.parent('li').hasClass(classes.removeTagParent)) {
              $(this).parent().remove();
            } else {
              $(selectors.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small">' + $el.text() + '</a></li>');
            }
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }
  
        updateScroll(true);
  
        history.pushState({}, '', newUrl);
        $(selectors.collectionGrid).addClass('unload');
        getNewCollectionContent(newUrl);
      });
    }
  
    function updateScroll(animate) {
      var scrollTo;
      if (theme.config.bpSmall) {
        // 60 is ~ height of sticky filters
        scrollTo = $('[data-scroll-to]').offset().top - 60;
      } else {
        scrollTo = $('#CollectionAjaxResult').offset().top + 1;
      }
  
      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $('.site-header').outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }
  
      if (animate) {
        $('html, body').animate({ scrollTop: scrollTo }, 300);
      } else {
        $('html, body').scrollTop(scrollTo);
      }
    }
  
    function setFilterStickyPosition() {
      var headerHeight = $('.site-header').outerHeight(true);
      $(selectors.filters).css('top', headerHeight + 10);
    }
  
    function getNewCollectionContent(url) {
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
        isAnimating = false;
        theme.reinitSection('collection-template');
        theme.collectionTemplate.reinit();
      }.bind(this));
    }
  
    function reinit() {
      settings.combineTags = $(selectors.sidebar).data('combine-tags');
  
      updateScroll(false);
  
      theme.reinitProductGridItem();
  
      // Trigger resize for sticky sidebar styles to update
      $('body').trigger('resize');
    }
  
    return {
      init: init,
      reinit: reinit
    };
  })();
  
  theme.customerTemplates = (function() {
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
  

  theme.Product = (function() {
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
      startingSlide: '.starting-slide'
    };
  
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.startingSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }
  
    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (!id.data) {return}
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          if (videos[playerId] && videos[playerId].loop) {
            player.playVideo();
          }
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.inModal = $container.closest('.modal').length;
      this.$modal;
  
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data('inventory') || false,
        incomingInventory: $container.data('incoming-inventory') || false,
        modalInit: false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        thumbArrows: false,
        thumbVertical: false,
        hasImages: true,
        hasMultipleImages: false,
        has3d: false,
        imageSize: '620x',
        videoLooping: $container.data('video-looping')
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }
  
      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
  
        video: 'ProductVideo-' + sectionId,
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,
        dotsContainer: '.product__photo-dots--' + sectionId,
  
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
        incomingInventory: '#ProductIncomingInventory-' + sectionId,
  
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,
  
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
  
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId
      };
  
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();
  
      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }
  
      this.init();
    }
  
    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('modalOpen.QuickShopModal-' + this.sectionId)
            .off('modalClose.QuickShopModal-' + this.sectionId);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();
  
          this.checkIfVideos();
          this.createImageCarousels();
          this.customMediaListners();
  
          // Add product id to recently viewed array
          this.addIdToRecentlyViewed();
        }
      },
  
      formSetup: function() {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(this.selectors.formContainer).find(this.selectors.singleOptionSelector);
        }
  
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.$container.attr('data-product-handle');
        var url = this.$container.attr('data-product-url');
        var aspectRatio = this.$container.attr('data-aspect-ratio');
        var featuredImage = this.$container.attr('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },
  
      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
  
      initVariants: function() {
        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }
  
        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
  
        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }
  
        this.variants = new theme.Variants(options);
  
        this.$container
          .on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this))
          .on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this))
          .on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this))
          .on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory || this.settings.incomingInventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
          this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);
  
          this.$variantSelectors.on('change' + this.settings.namespace, this.updateVariantAvailability.bind(this));
  
          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject, true);
        }
      },
  
      initQtySelector: function() {
        this.$container.find('.js-qty__wrapper').each(function() {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
  
      /*============================================================================
        Dynamic variant availability
          - To disable, set dynamicVariantsEnable to false in theme.liquid
      ==============================================================================*/
      setCurrentVariantAvailability: function(variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };
  
        // Disable all options to start
        this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));
  
        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
          if (variant.id === el.id) {
            return false;
          }
  
          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });
  
  
        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };
  
        availableVariants = Object.assign({}, variantObject, availableVariants);
  
        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;
  
            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }
  
        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
      },
  
      updateVariantAvailability: function(evt, value, index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }
  
        var variants = this.variantsObject.filter(function(el) {
          return el[optionIndex] === newVal;
        });
  
        // Disable all buttons/dropdown options that aren't the current index
        $(this.selectors.formContainer).find('.variant-input-wrap').each(function(index, el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');
  
          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);
  
            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              this.enableVariantOption($group, variants[i][currentOptionIndex]);
            }
          }
        }.bind(this));
      },
  
      disableVariantGroup: function($group) {
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option').prop('disabled', true)
        } else {
          $group.find('input').prop('disabled', true);
          $group.find('label').toggleClass('disabled', true);
        }
      },
  
      enableVariantOptionByValue: function(array, index) {
        var $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="'+ index +'"]');
  
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption($group, array[i]);
        }
      },
  
      enableVariantOption: function($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option[value="'+ value +'"]').prop('disabled', false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="'+ value +'"]');
          $buttonGroup.find('input').prop('disabled', false);
          $buttonGroup.find('label').toggleClass('disabled', false);
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },
  
      updateCartButton: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            var defaultText = $(this.selectors.addToCartText).data('default-text');
            $(this.selectors.addToCartText).html(defaultText);
          } else {
            // Sold out, disable the submit button and change text
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
            $(this.selectors.addToCartText).html(theme.strings.soldOut);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          // Regular price
$(this.selectors.price).html('<span class="money" data-variant-id="' + variant.id + '">' + theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat) + '</span>').show();
// Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
  
            $(this.selectors.savePrice)
              .removeClass('hide')
              .html(theme.strings.savePrice.replace('[saved_amount]', savings));
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
            $(this.selectors.savePrice).addClass('hide')
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.variant;
  
        if (variant && variant.unit_price) {
          $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat));
          $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
          $(this.selectors.unitWrapper).removeClass('hide').removeClass(classes.visuallyHide);
        } else {
          $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
        }
      },
  
      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          $(this.selectors.sku).html(newSku);
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.variant;
  
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
          variantInventoryObject = window.inventories[this.sectionId][variant.id];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(showInventory, quantity);
  
          if (!showInventory && variantInventoryObject.incoming) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      toggleInventoryQuantity: function(show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        if (show) {
          $(this.selectors.inventory)
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]', qty));
        } else {
          $(this.selectors.inventory).addClass('hide');
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false;
        }
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          $(this.selectors.incomingInventory)
            .removeClass('hide')
            .text(string);
        } else {
          $(this.selectors.incomingInventory).addClass('hide');
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);
  
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
  
        var videoTypes = [];
  
        $productVideos.each(function() {
          var type = $(this).data('video-type');
  
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
  
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            theme.LibraryLoader.load('youtubeSdk');
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
  
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
  
        return videoTypes;
      },
  
      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
  
      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
  
          videos[id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            loop: $el.data('video-loop'),
            attemptedToPlay: false,
            events: {
              onReady: function(evt) {
                onVideoPlayerReady(evt, id);
              },
              onStateChange: function(evt) {
                onVideoStateChange(evt, id);
              }
            }
          };
        });
  
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
  
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }
  
              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
  
        youtubeReady = true;
      },
  
      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
  
      stopVideo: function(id, type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopMp4Video();
        }
  
        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }
  
        if (type === 'mp4') {
          this.stopMp4Video(id);
        }
      },
  
      getVideoType: function($video) {
        return $video.data('video-type');
      },
  
      getVideoId: function($video) {
        return $video.attr('id');
      },
  
      // Sub video functions (MP4 and YouTube)
      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          setTimeout(function() {
            this.playYoutubeVideo(id, forcePlay);
          }.bind(this), 1000);
          return;
        }
  
        this.playYoutubeVideo(id, forcePlay);
      },
  
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
  
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
  
      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
  
      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
  
        var playPromise = $player[0].play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {})
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            $player[0].setAttribute('controls', '');
            $player.closest(selectors.videoParent).attr('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (player && typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var $container = $(this.selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
        var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));
  
        // No image, bail
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        this.$mainSlider.slick('slickGoTo', imageIndex);
      },
  
      initImageSwitch: function() {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }
  
        $(this.selectors.photoThumbs)
          .on('click', function(evt) {
            evt.preventDefault();
          })
          .on('focus', function(evt) {
            if (!this.settings.slickThumbInitialized) { return }
            var index = $(evt.currentTarget).data('index');
            if (index !== undefined) {
              this.$thumbSlider.slick('slickGoTo', index);
            }
          }.bind(this))
          .on('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.$container.find(selectors.currentSlide).focus();
            }
          }.bind(this));
      },
  
      createImageCarousels: function() {
        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
          return;
        }
  
        this.settings.hasMultipleImages = true;
        this.settings.has3d = this.$container.find(this.selectors.media).length;
  
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
  
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));
  
        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: this.settings.has3d ? false : true,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          initialSlide: startIndex,
          appendDots: this.selectors.dotsContainer
        };
  
        this.thumbSliderArgs = {
          accessibility: false,
          initialSlide: startIndex
        };
  
        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);
  
        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall matchLarge', function() {
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
        }.bind(this));
  
        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },
  
      initSliders: function(args) {
        this.destroyImageCarousels();
        this.$mainSlider.slick(args.main);
        if (!theme.config.bpSmall) {
          this.$thumbSlider.slick(args.thumbs);
        }
  
        this.settings.slickMainInitialized = true;
      },
  
      setSliderArgs: function() {
        var args = {};
  
        var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
        var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data('arrows');
  
        var slidesToShow = thumbnailsVertical && thumbArrows ? 1 :
                           (thumbnailsVertical ? 3 : 5);
  
        if (theme.config.bpSmall) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: thumbnailsVertical ? false : true,
            dots: false,
            infinite: false,
            fade: true
          });
          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: this.selectors.mainSlider,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbArrows ? false : thumbnailsVertical,
            customSlideAdvancement: true
          });
        }
  
        return args;
      },
  
      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }
  
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
  
        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },
  
      mainSlideInit: function(event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);
  
        if (!$video.length) {
          return;
        }
  
        this.initVideo($video);
      },
  
      thumbSlideInit: function(event, slick) {
        this.settings.slickThumbInitialized = true;
  
        // Check if we need to hide the arrows
        if (this.settings.thumbArrows) {
          this.$thumbSlider.on('setPosition', this.thumbSlideArrowVisibility.bind(this));
        }
      },
  
      thumbSlideArrowVisibility: function(event, slick) {
        var $slider = slick.$slider;
        var $arrows = $slider.find('.slick-arrow');
        var showArrows = false;
  
        if (this.settings.thumbVertical) {
          var $trackHeight = $slider.find('.slick-track').height();
          if ($trackHeight >= $slider.height()) {
            showArrows = true;
          }
        } else {
          var $trackWidth = $slider.find('.slick-track').width();
          if ($trackWidth >= $slider.width()) {
            showArrows = true;
          }
        }
  
        if (showArrows) {
          $arrows.removeClass('hide');
        } else {
          $arrows.addClass('hide');
        }
      },
  
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');
  
        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
  
          if (prevVideoId) {
            this.stopVideo(prevVideoId, prevVideoType);
          }
        }
  
        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
  
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
  
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
  
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
  
        // Pause any existing media
        var $currentMedia = $currentSlide.find(this.selectors.media);
        if ($currentMedia.length) {
          $currentMedia.trigger('mediaHidden');
        }
  
        // Prep next slide media
        var $nextMedia = $nextSlide.find(this.selectors.media);
        if ($nextMedia.length) {
          $nextMedia.trigger('mediaVisible');
          $nextSlide.find('.shopify-model-viewer-ui__button').attr('tabindex', 0);
          $nextSlide.find('.product-single__close-media').attr('tabindex', 0);
        }
      },
  
      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }
  
        $(window).trigger('resize.slick');
        setTimeout(function() {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this), 500); // same timing as modal open transition
      },
  
      _slideIndex: function($el) {
        return $el.data('index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        if (!this.settings.modalInit) {
          var $formHolder = $(this.selectors.modalFormHolder);
          var url = $formHolder.data('url');
          var template = $formHolder.data('template');
  
          // If no alt template, use stripped down ajax version
          if (!template) {
            url = url + '?view=ajax';
          }
  
          $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
            $formHolder.addClass('is-active');
            this.formSetup();
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }.bind(this));
  
          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.customMediaListners();
          this.settings.modalInit = true;
        }
  
        this.resizeSlides();
  
        // Add product id to recently viewed array
        this.addIdToRecentlyViewed();
      },
  
      closeModalProduct: function() {
        this.stopVideo();
        $('body').off(this.settings.namespace);
        $(window).off(this.settings.namespace);
      },
  
      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
  
        // Lazyload mp4 videos
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal
            .find('.product__video[data-video-type="mp4"]')
            .find('.product__video-src')
            .each(function(i, video) {
              var $el = $(video);
              var src = $el.attr('src');
              var type = $el.attr('type')
              var newEl = document.createElement('source');
              newEl.src = src;
              newEl.type = type;
              $el.after(newEl);
            }.bind(this));
        }
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var $modelViewerElements = $(
          this.selectors.media,
          this.$container
        );
  
        if ($modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init($modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        var self = this;
        $(document).on('shopify_xr_launch', function() {
          var $currentMedia = $(
            self.selectors.productMediaWrapper +
              ':not(.' +
              classes.hidden +
              ')',
            self.$container
          );
          $currentMedia.trigger('xrLaunch');
        });
      },
  
      customMediaListners: function() {
        $('body').on('click', this.selectors.closeMedia, function() {
          this.$mainSlider
            .find(selectors.currentSlide)
            .find(this.selectors.media)
            .trigger('mediaHidden');
        }.bind(this));
  
        this.$container.find('model-viewer')
          .on('shopify_model_viewer_ui_toggle_play', function(evt) {
            this.mediaLoaded(evt);
          }.bind(this))
          .on('shopify_model_viewer_ui_toggle_pause', function(evt) {
            this.mediaUnloaded(evt);
          }.bind(this));
      },
  
      mediaLoaded: function(evt) {
        this.$container.find(this.selectors.closeMedia).removeClass('hide');
        this.toggleSliderSwiping(false);
      },
  
      mediaUnloaded: function(evt) {
        this.$container.find(this.selectors.closeMedia).addClass('hide');
        this.toggleSliderSwiping(true);
      },
  
      toggleSliderSwiping: function(enable) {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('slickSetOption', 'swipe', enable);
          this.$mainSlider.slick('slickSetOption', 'draggable', enable);
          this.$mainSlider.slick('slickSetOption', 'touchMove', enable);
          this.$mainSlider.slick('slickSetOption', 'accessibility', enable);
        }
      },
  
      onUnload: function() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
        theme.ProductMedia.removeSectionModels(this.sectionId);
      }
    });
  
    return Product;
  })();
  
  theme.Recommendations = (function() {
  
    function Recommendations(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.url = $container.data('url');
  
      this.selectors = {
        recommendations: '#Recommendations-' + sectionId,
        placeholder: '.product-recommendations-placeholder',
        sectionClass: ' .product-recommendations',
        productResults: '.grid-product'
      };
  
      this.init();
    }
  
    Recommendations.prototype = $.extend({}, Recommendations.prototype, {
      init: function() {
        var $section = $(this.selectors.recommendations);
  
        if (!$section.length || $section.data('enable') === false) {
          return;
        }
  
        var $placeholder = $section.find(this.selectors.placeholder);
        var id = $section.data('product-id');
        var limit = $section.data('limit');
  
        var url = this.url + '?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        $placeholder.load(url + this.selectors.sectionClass, function(data) {
          theme.reinitProductGridItem($section);
          this.updateVariantInventory($section);
  
          // If no results, hide the entire section
          if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
            $section.addClass('hide');
          }
        }.bind(this));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateVariantInventory: function($section) {
        window.inventories = window.inventories || {};
  
        $section.find('.js-product-inventory-data').each(function() {
          var $el = $(this);
          var sectionId = $el.data('section-id');
          window.inventories[sectionId] = {};
          $('.js-variant-inventory-data', $el).each(function() {
            var $child = $(this);
            window.inventories[sectionId][$child.data('id')] = {
              'quantity': $child.data('quantity'),
              'incoming': $child.data('incoming'),
              'next_incoming_date': $child.data('date')
            }
          });
        });
      }
    });
  
    return Recommendations;
  })();
  
  theme.CollectionHeader = (function() {
  
    var selectors = {
      hero: '.collection-hero',
      parallaxContainer: '.parallax-container'
    };
  
    function CollectionHeader(container) {
      var $container = $(container);
      this.namespace = '.collection-header';
  
      var $heroImageContainer = this.$heroContainer = $container.find(selectors.hero);
      if ($heroImageContainer.length) {
        this.checkIfNeedReload();
  
        if ($container.data('parallax')) {
          var $parallaxContainer = $container.find(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
        }
      } else {
        // Prevent 'Overlay header over collection' header setting
        // from breaking layout. Required because settings from two
        // different sections rely on each other on page load.
        theme.headerNav.disableOverlayHeader();
      }
    }
  
    CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (!theme.settings.overlayHeader) {
          return;
        }
        var $header = $('.header-wrapper');
        if (!$header.hasClass('is-light') && !$('.header-wrapper').hasClass('header-wrapper--sticky')) {
          location.reload();
        }
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
  
    function CollectionSidebar(container) {
      this.$container = $(container);
      this.init();
    }
  
    CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
      init: function() {
        // Force close the drawer if it exists
        this.onUnload();
  
        drawerStyle = this.$container.data('style') === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
  
    var selectors = {
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
      sortSelect: '#SortBy'
    };
  
    var data = {
      sortBy: 'data-default-sortby'
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      this.init();
    }
  
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        var sectionId = this.sectionId = this.$container.attr('data-section-id');
        this.namespace = '.collection-' + sectionId;
  
        this.$sortSelect = $(selectors.sortSelect);
        this.$sortSelect.on('change', this.onSortChange.bind(this));
        this.defaultSort = this.getDefaultSortValue();
  
        this.initParams();
        this.colorSwatchHovering();
  
        theme.reinitSection('collection-sidebar');
      },
  
      initParams: function() {
        this.queryParams = {};
  
        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },
  
      getSortValue: function() {
        return this.$sortSelect.val() || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.$sortSelect.attr(data.sortBy);
      },
  
      onSortChange: function() {
        this.queryParams.sort_by = this.getSortValue();
  
        if (this.queryParams.page) {
          delete this.queryParams.page;
        }
  
        window.location.search = $.param(this.queryParams);
      },
  
      colorSwatchHovering: function() {
        var $colorImage = $(selectors.colorSwatchImage);
        if (!$colorImage.length) {
          return;
        }
  
        $(selectors.colorSwatch).on({
          mouseenter: function (evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            var image = $el.data('variant-image');
            $('.grid-product__color-image--' + id)
              .css('background-image', 'url(' + image + ')')
              .addClass('is-active');
          },
          mouseleave: function (evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            $('.grid-product__color-image--' + id).removeClass('is-active');
          }
        });
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
        $(selectors.colorSwatch).off(this.namespace);
      }
    });
  
    return Collection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist',
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };
  
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };
  
    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected
      theme.reinitSection('slideshow-section');
  
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();
  
      this.cache = {};
      this.cacheSelectors();
  
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
  
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
  
      // Set a timer to resize the header in case the logo changes size
      if (Shopify.designMode) {
        setTimeout(function() {
          $('body').trigger('resize');
        }, 500);
      }
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      cacheSelectors: function() {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
  
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
  
        this.drawerMenuButtons();
      },
  
      drawerMenuButtons: function() {
        $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
          evt.preventDefault();
          theme.NavDrawer.close();
        });
  
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
  
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
  
        $mobileSubNavToggle.on('click', function() {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;
  
          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }
  
          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
  
      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
  
      onDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
  
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
  
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
  
    return Header;
  
  })();
  
  theme.FooterSection = (function() {
  
    var selectors = {
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };
  
    function Footer(container) {
      var $container = this.$container = $(container);
  
      this.cache = {};
      this.cacheSelectors();
  
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
  
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
    }
  
    Footer.prototype = $.extend({}, Footer.prototype, {
      cacheSelectors: function() {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
  
      onUnload: function() {
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
  
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
  
    return Footer;
  })();
  
  theme.FeaturedContentSection = (function() {
  
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
  
    return FeaturedContent;
  })();
  
  theme.slideshows = {};
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;
  
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
  
      this.init();
  
      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
      }
    }
  
    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function() {
        // Prevent slideshows from initializing on top of themselves
        this.onUnload();
  
        var $slideshow = $(this.slideshow);
        var args = {
          autoplay: $slideshow.data('autoplay'),
          arrows: $slideshow.data('arrows'),
          dots: $slideshow.data('dots'),
          fade: true,
          speed: 500 // same as $slideshowImageAnimationSpeed in CSS
        };
  
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },
  
      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },
  
      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },
  
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
  
        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
  
      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.video-parent-section',
      promoContainer: '.promo-grid__container'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };
  
    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
  
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
  
      this.vimeoPlayer = [];
  
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
  
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
  
      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
  
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          $mp4Div.attr('controls', '');
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }
  
    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }
  
    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data ? id.data.id : false;
      }
  
      if (playerId) {
        if (theme.isElementVisible($('#' + playerId))) {
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
  
      $el
        .closest(selectors.promoContainer)
        .addClass(classes.interactable);
    }
  
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false,
          events: {
            onReady: function(evt) {
              onVideoPlayerReady(evt, this.youtubePlayerId);
            }.bind(this),
            onStateChange: function(evt) {
              onVideoStateChange(evt, this.youtubePlayerId);
            }.bind(this)
          }
        };
  
        if (!youtubeReady) {
          theme.LibraryLoader.load('youtubeSdk');
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
  
      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
  
        youtubeReady = true;
      },
  
      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
  
      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
  
    return videoSection;
  })();
  
  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };
  
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    }
  
    backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
      onUnload: function(evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
  
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
  
      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        this.init($slider, defaults);
      }.bind(this));
    }
  
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
  
        obj.slick(args);
        this.sliderActive = true;
  
        if (AOS) {
          AOS.refresh();
        }
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Testimonials;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: $container.data('test-mode')
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }
  
      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
  
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      },
  
      onUnload: function() {}
    });
  
    return NewsletterPopup;
  })();
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
  
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };
  
    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
  
      if (!this.key) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }
  
    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
  
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
  
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
  
        deferred.resolve(results);
      });
  
      return deferred;
    }
  
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
  
      createMap: function() {
        var $map = this.$map;
  
        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
  
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
  
    return Map;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');
  
        if (!$filterBy.length) {
          return;
        }
  
        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      onUnload: function() {
  
      }
    });
  
    return Blog;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };
  
    function Photoswipe(container, sectionId) {
      this.$container = $(container);
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;
  
      if (this.$container.attr('data-zoom') === 'false') {
        return;
      }
  
      if (this.$container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var $trigger = this.$container.find(selectors.trigger);
        this.$images = this.$container.find(selectors.images);
        var items = [];
  
        // Init gallery on active image
        $trigger.on('click' + this.namespace, function(evt) {
          items = this.getImageData();
          if (this.inSlideshow) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items, index);
        }.bind(this));
      },
  
      getImageData: function() {
        var haveImages = false;
        var items = [];
        var options = {};
  
        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  
        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },
  
      afterChange: function() {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo', newIndex);
          }
        }
      }
    });
  
    return Photoswipe;
  })();
  
  

  // Medium breakpoint is also set in theme.css.liquid and inline throughout some templates.
  // Do not change values unless you know what you're doing.
  theme.bp = {};
  theme.bp.smallUp = 769;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: 'screen and (max-width: '+ theme.bp.small +'px)',
    mediaQuerySmallUp: 'screen and (min-width: '+ theme.bp.smallUp +'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1),
    stickyHeader: false,
    recentlyViewed: []
  };

  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }

  theme.recentlyViewed = {
    recent: {}, // will store handle+url of recent products
    productInfo: {} // will store product data to reduce API calls
  };

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  }

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  }

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  theme.init = function() {
    theme.setGlobals();
    theme.collapsibles.init();
    theme.rte.init();

    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });

    $(document.documentElement).on('keyup.tab', function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });

    // Change email icon to submit text
    $('.footer__newsletter-input').on('keyup', function() {
      $(this).addClass('footer__newsletter-input--active');
    });
  };

  theme.initSecondary = function() {
    theme.initQuickShop();
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }
    theme.collectionTemplate.init();
    theme.customerTemplates.init();
    theme.videoModal();
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isStorageSupported('session');
    theme.config.hasLocalStorage = theme.isStorageSupported('local');

    if (theme.config.hasLocalStorage) {
      theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

      if (theme.recentlyViewed.localStorage) {
        theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
      }
    }

    theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });

    enquire.register(theme.config.mediaQuerySmallUp, {
      match: function() {
        $('body').trigger('matchLarge');
      },
      unmatch: function() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  };

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.reinitSection = function(section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  };

  theme.reinitProductGridItem = function($scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    // Reload quick shop buttons
    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();SPR.loadBadges();
    }

    // Re-register product templates in quick view modals.
    // Will not double-register.
    sections.register('product-template', theme.Product, $scope);

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  $(document).ready(function() {
    theme.init();

    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('background-image', theme.BackgroundImage);
    sections.register('recently-viewed', theme.RecentlyViewed);
    sections.register('product', theme.Product);
    sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template', theme.Product);
    sections.register('collection-header', theme.CollectionHeader);
    sections.register('collection-sidebar', theme.CollectionSidebar);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('testimonials', theme.Testimonials);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
    sections.register('photoswipe', theme.Photoswipe);
    sections.register('footer-section', theme.FooterSection);

    theme.initSecondary();

    // Change placeholder for Search input
    var placeHolder = ['Search for anything, e.g. "burgundy under 100"','Search for anything, e.g. "cabernet above 100"'];
    var n=0;
    var loopLength=placeHolder.length;

    setInterval(function(){
      if(n<loopLength){
        var newPlaceholder = placeHolder[n];
        n++;
        $('.home-page_search__form-input').attr('placeholder',newPlaceholder);
      } else {
        $('.home-page_search__form-input').attr('placeholder',placeHolder[0]);
        n=0;
      }
    },2000);
  });

  /*! jQuery UI - v1.12.1 - 2020-11-09
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/tabs.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

  (function( factory ) {
    if ( typeof define === "function" && define.amd ) {

      // AMD. Register as an anonymous module.
      define([ "jquery" ], factory );
    } else {

      // Browser globals
      factory( jQuery );
    }
  }(function( $ ) {

    $.ui = $.ui || {};

    var version = $.ui.version = "1.12.1";


    /*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/



    var widgetUuid = 0;
    var widgetSlice = Array.prototype.slice;

    $.cleanData = ( function( orig ) {
      return function( elems ) {
        var events, elem, i;
        for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
          try {

            // Only trigger remove when necessary to save time
            events = $._data( elem, "events" );
            if ( events && events.remove ) {
              $( elem ).triggerHandler( "remove" );
            }

            // Http://bugs.jquery.com/ticket/8235
          } catch ( e ) {}
        }
        orig( elems );
      };
    } )( $.cleanData );

    $.widget = function( name, base, prototype ) {
      var existingConstructor, constructor, basePrototype;

      // ProxiedPrototype allows the provided prototype to remain unmodified
      // so that it can be used as a mixin for multiple widgets (#8876)
      var proxiedPrototype = {};

      var namespace = name.split( "." )[ 0 ];
      name = name.split( "." )[ 1 ];
      var fullName = namespace + "-" + name;

      if ( !prototype ) {
        prototype = base;
        base = $.Widget;
      }

      if ( $.isArray( prototype ) ) {
        prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
      }

      // Create selector for plugin
      $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
        return !!$.data( elem, fullName );
      };

      $[ namespace ] = $[ namespace ] || {};
      existingConstructor = $[ namespace ][ name ];
      constructor = $[ namespace ][ name ] = function( options, element ) {

        // Allow instantiation without "new" keyword
        if ( !this._createWidget ) {
          return new constructor( options, element );
        }

        // Allow instantiation without initializing for simple inheritance
        // must use "new" keyword (the code above always passes args)
        if ( arguments.length ) {
          this._createWidget( options, element );
        }
      };

      // Extend with the existing constructor to carry over any static properties
      $.extend( constructor, existingConstructor, {
        version: prototype.version,

        // Copy the object used to create the prototype in case we need to
        // redefine the widget later
        _proto: $.extend( {}, prototype ),

        // Track widgets that inherit from this widget in case this widget is
        // redefined after a widget inherits from it
        _childConstructors: []
      } );

      basePrototype = new base();

      // We need to make the options hash a property directly on the new instance
      // otherwise we'll modify the options hash on the prototype that we're
      // inheriting from
      basePrototype.options = $.widget.extend( {}, basePrototype.options );
      $.each( prototype, function( prop, value ) {
        if ( !$.isFunction( value ) ) {
          proxiedPrototype[ prop ] = value;
          return;
        }
        proxiedPrototype[ prop ] = ( function() {
          function _super() {
            return base.prototype[ prop ].apply( this, arguments );
          }

          function _superApply( args ) {
            return base.prototype[ prop ].apply( this, args );
          }

          return function() {
            var __super = this._super;
            var __superApply = this._superApply;
            var returnValue;

            this._super = _super;
            this._superApply = _superApply;

            returnValue = value.apply( this, arguments );

            this._super = __super;
            this._superApply = __superApply;

            return returnValue;
          };
        } )();
      } );
      constructor.prototype = $.widget.extend( basePrototype, {

        // TODO: remove support for widgetEventPrefix
        // always use the name + a colon as the prefix, e.g., draggable:start
        // don't prefix for widgets that aren't DOM-based
        widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
      }, proxiedPrototype, {
        constructor: constructor,
        namespace: namespace,
        widgetName: name,
        widgetFullName: fullName
      } );

      // If this widget is being redefined then we need to find all widgets that
      // are inheriting from it and redefine all of them so that they inherit from
      // the new version of this widget. We're essentially trying to replace one
      // level in the prototype chain.
      if ( existingConstructor ) {
        $.each( existingConstructor._childConstructors, function( i, child ) {
          var childPrototype = child.prototype;

          // Redefine the child widget using the same prototype that was
          // originally used, but inherit from the new version of the base
          $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
              child._proto );
        } );

        // Remove the list of existing child constructors from the old constructor
        // so the old child constructors can be garbage collected
        delete existingConstructor._childConstructors;
      } else {
        base._childConstructors.push( constructor );
      }

      $.widget.bridge( name, constructor );

      return constructor;
    };

    $.widget.extend = function( target ) {
      var input = widgetSlice.call( arguments, 1 );
      var inputIndex = 0;
      var inputLength = input.length;
      var key;
      var value;

      for ( ; inputIndex < inputLength; inputIndex++ ) {
        for ( key in input[ inputIndex ] ) {
          value = input[ inputIndex ][ key ];
          if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

            // Clone objects
            if ( $.isPlainObject( value ) ) {
              target[ key ] = $.isPlainObject( target[ key ] ) ?
                  $.widget.extend( {}, target[ key ], value ) :

                  // Don't extend strings, arrays, etc. with objects
                  $.widget.extend( {}, value );

              // Copy everything else by reference
            } else {
              target[ key ] = value;
            }
          }
        }
      }
      return target;
    };

    $.widget.bridge = function( name, object ) {
      var fullName = object.prototype.widgetFullName || name;
      $.fn[ name ] = function( options ) {
        var isMethodCall = typeof options === "string";
        var args = widgetSlice.call( arguments, 1 );
        var returnValue = this;

        if ( isMethodCall ) {

          // If this is an empty collection, we need to have the instance method
          // return undefined instead of the jQuery instance
          if ( !this.length && options === "instance" ) {
            returnValue = undefined;
          } else {
            this.each( function() {
              var methodValue;
              var instance = $.data( this, fullName );

              if ( options === "instance" ) {
                returnValue = instance;
                return false;
              }

              if ( !instance ) {
                return $.error( "cannot call methods on " + name +
                    " prior to initialization; " +
                    "attempted to call method '" + options + "'" );
              }

              if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
                return $.error( "no such method '" + options + "' for " + name +
                    " widget instance" );
              }

              methodValue = instance[ options ].apply( instance, args );

              if ( methodValue !== instance && methodValue !== undefined ) {
                returnValue = methodValue && methodValue.jquery ?
                    returnValue.pushStack( methodValue.get() ) :
                    methodValue;
                return false;
              }
            } );
          }
        } else {

          // Allow multiple hashes to be passed on init
          if ( args.length ) {
            options = $.widget.extend.apply( null, [ options ].concat( args ) );
          }

          this.each( function() {
            var instance = $.data( this, fullName );
            if ( instance ) {
              instance.option( options || {} );
              if ( instance._init ) {
                instance._init();
              }
            } else {
              $.data( this, fullName, new object( options, this ) );
            }
          } );
        }

        return returnValue;
      };
    };

    $.Widget = function( /* options, element */ ) {};
    $.Widget._childConstructors = [];

    $.Widget.prototype = {
      widgetName: "widget",
      widgetEventPrefix: "",
      defaultElement: "<div>",

      options: {
        classes: {},
        disabled: false,

        // Callbacks
        create: null
      },

      _createWidget: function( options, element ) {
        element = $( element || this.defaultElement || this )[ 0 ];
        this.element = $( element );
        this.uuid = widgetUuid++;
        this.eventNamespace = "." + this.widgetName + this.uuid;

        this.bindings = $();
        this.hoverable = $();
        this.focusable = $();
        this.classesElementLookup = {};

        if ( element !== this ) {
          $.data( element, this.widgetFullName, this );
          this._on( true, this.element, {
            remove: function( event ) {
              if ( event.target === element ) {
                this.destroy();
              }
            }
          } );
          this.document = $( element.style ?

              // Element within the document
              element.ownerDocument :

              // Element is window or document
              element.document || element );
          this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
        }

        this.options = $.widget.extend( {},
            this.options,
            this._getCreateOptions(),
            options );

        this._create();

        if ( this.options.disabled ) {
          this._setOptionDisabled( this.options.disabled );
        }

        this._trigger( "create", null, this._getCreateEventData() );
        this._init();
      },

      _getCreateOptions: function() {
        return {};
      },

      _getCreateEventData: $.noop,

      _create: $.noop,

      _init: $.noop,

      destroy: function() {
        var that = this;

        this._destroy();
        $.each( this.classesElementLookup, function( key, value ) {
          that._removeClass( value, key );
        } );

        // We can probably remove the unbind calls in 2.0
        // all event bindings should go through this._on()
        this.element
            .off( this.eventNamespace )
            .removeData( this.widgetFullName );
        this.widget()
            .off( this.eventNamespace )
            .removeAttr( "aria-disabled" );

        // Clean up events and states
        this.bindings.off( this.eventNamespace );
      },

      _destroy: $.noop,

      widget: function() {
        return this.element;
      },

      option: function( key, value ) {
        var options = key;
        var parts;
        var curOption;
        var i;

        if ( arguments.length === 0 ) {

          // Don't return a reference to the internal hash
          return $.widget.extend( {}, this.options );
        }

        if ( typeof key === "string" ) {

          // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
          options = {};
          parts = key.split( "." );
          key = parts.shift();
          if ( parts.length ) {
            curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
            for ( i = 0; i < parts.length - 1; i++ ) {
              curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
              curOption = curOption[ parts[ i ] ];
            }
            key = parts.pop();
            if ( arguments.length === 1 ) {
              return curOption[ key ] === undefined ? null : curOption[ key ];
            }
            curOption[ key ] = value;
          } else {
            if ( arguments.length === 1 ) {
              return this.options[ key ] === undefined ? null : this.options[ key ];
            }
            options[ key ] = value;
          }
        }

        this._setOptions( options );

        return this;
      },

      _setOptions: function( options ) {
        var key;

        for ( key in options ) {
          this._setOption( key, options[ key ] );
        }

        return this;
      },

      _setOption: function( key, value ) {
        if ( key === "classes" ) {
          this._setOptionClasses( value );
        }

        this.options[ key ] = value;

        if ( key === "disabled" ) {
          this._setOptionDisabled( value );
        }

        return this;
      },

      _setOptionClasses: function( value ) {
        var classKey, elements, currentElements;

        for ( classKey in value ) {
          currentElements = this.classesElementLookup[ classKey ];
          if ( value[ classKey ] === this.options.classes[ classKey ] ||
              !currentElements ||
              !currentElements.length ) {
            continue;
          }

          // We are doing this to create a new jQuery object because the _removeClass() call
          // on the next line is going to destroy the reference to the current elements being
          // tracked. We need to save a copy of this collection so that we can add the new classes
          // below.
          elements = $( currentElements.get() );
          this._removeClass( currentElements, classKey );

          // We don't use _addClass() here, because that uses this.options.classes
          // for generating the string of classes. We want to use the value passed in from
          // _setOption(), this is the new value of the classes option which was passed to
          // _setOption(). We pass this value directly to _classes().
          elements.addClass( this._classes( {
            element: elements,
            keys: classKey,
            classes: value,
            add: true
          } ) );
        }
      },

      _setOptionDisabled: function( value ) {
        this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

        // If the widget is becoming disabled, then nothing is interactive
        if ( value ) {
          this._removeClass( this.hoverable, null, "ui-state-hover" );
          this._removeClass( this.focusable, null, "ui-state-focus" );
        }
      },

      enable: function() {
        return this._setOptions( { disabled: false } );
      },

      disable: function() {
        return this._setOptions( { disabled: true } );
      },

      _classes: function( options ) {
        var full = [];
        var that = this;

        options = $.extend( {
          element: this.element,
          classes: this.options.classes || {}
        }, options );

        function processClassString( classes, checkOption ) {
          var current, i;
          for ( i = 0; i < classes.length; i++ ) {
            current = that.classesElementLookup[ classes[ i ] ] || $();
            if ( options.add ) {
              current = $( $.unique( current.get().concat( options.element.get() ) ) );
            } else {
              current = $( current.not( options.element ).get() );
            }
            that.classesElementLookup[ classes[ i ] ] = current;
            full.push( classes[ i ] );
            if ( checkOption && options.classes[ classes[ i ] ] ) {
              full.push( options.classes[ classes[ i ] ] );
            }
          }
        }

        this._on( options.element, {
          "remove": "_untrackClassesElement"
        } );

        if ( options.keys ) {
          processClassString( options.keys.match( /\S+/g ) || [], true );
        }
        if ( options.extra ) {
          processClassString( options.extra.match( /\S+/g ) || [] );
        }

        return full.join( " " );
      },

      _untrackClassesElement: function( event ) {
        var that = this;
        $.each( that.classesElementLookup, function( key, value ) {
          if ( $.inArray( event.target, value ) !== -1 ) {
            that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
          }
        } );
      },

      _removeClass: function( element, keys, extra ) {
        return this._toggleClass( element, keys, extra, false );
      },

      _addClass: function( element, keys, extra ) {
        return this._toggleClass( element, keys, extra, true );
      },

      _toggleClass: function( element, keys, extra, add ) {
        add = ( typeof add === "boolean" ) ? add : extra;
        var shift = ( typeof element === "string" || element === null ),
            options = {
              extra: shift ? keys : extra,
              keys: shift ? element : keys,
              element: shift ? this.element : element,
              add: add
            };
        options.element.toggleClass( this._classes( options ), add );
        return this;
      },

      _on: function( suppressDisabledCheck, element, handlers ) {
        var delegateElement;
        var instance = this;

        // No suppressDisabledCheck flag, shuffle arguments
        if ( typeof suppressDisabledCheck !== "boolean" ) {
          handlers = element;
          element = suppressDisabledCheck;
          suppressDisabledCheck = false;
        }

        // No element argument, shuffle and use this.element
        if ( !handlers ) {
          handlers = element;
          element = this.element;
          delegateElement = this.widget();
        } else {
          element = delegateElement = $( element );
          this.bindings = this.bindings.add( element );
        }

        $.each( handlers, function( event, handler ) {
          function handlerProxy() {

            // Allow widgets to customize the disabled handling
            // - disabled as an array instead of boolean
            // - disabled class as method for disabling individual parts
            if ( !suppressDisabledCheck &&
                ( instance.options.disabled === true ||
                    $( this ).hasClass( "ui-state-disabled" ) ) ) {
              return;
            }
            return ( typeof handler === "string" ? instance[ handler ] : handler )
                .apply( instance, arguments );
          }

          // Copy the guid so direct unbinding works
          if ( typeof handler !== "string" ) {
            handlerProxy.guid = handler.guid =
                handler.guid || handlerProxy.guid || $.guid++;
          }

          var match = event.match( /^([\w:-]*)\s*(.*)$/ );
          var eventName = match[ 1 ] + instance.eventNamespace;
          var selector = match[ 2 ];

          if ( selector ) {
            delegateElement.on( eventName, selector, handlerProxy );
          } else {
            element.on( eventName, handlerProxy );
          }
        } );
      },

      _off: function( element, eventName ) {
        eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
            this.eventNamespace;
        element.off( eventName ).off( eventName );

        // Clear the stack to avoid memory leaks (#10056)
        this.bindings = $( this.bindings.not( element ).get() );
        this.focusable = $( this.focusable.not( element ).get() );
        this.hoverable = $( this.hoverable.not( element ).get() );
      },

      _delay: function( handler, delay ) {
        function handlerProxy() {
          return ( typeof handler === "string" ? instance[ handler ] : handler )
              .apply( instance, arguments );
        }
        var instance = this;
        return setTimeout( handlerProxy, delay || 0 );
      },

      _hoverable: function( element ) {
        this.hoverable = this.hoverable.add( element );
        this._on( element, {
          mouseenter: function( event ) {
            this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
          },
          mouseleave: function( event ) {
            this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
          }
        } );
      },

      _focusable: function( element ) {
        this.focusable = this.focusable.add( element );
        this._on( element, {
          focusin: function( event ) {
            this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
          },
          focusout: function( event ) {
            this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
          }
        } );
      },

      _trigger: function( type, event, data ) {
        var prop, orig;
        var callback = this.options[ type ];

        data = data || {};
        event = $.Event( event );
        event.type = ( type === this.widgetEventPrefix ?
            type :
            this.widgetEventPrefix + type ).toLowerCase();

        // The original event may come from any element
        // so we need to reset the target on the new event
        event.target = this.element[ 0 ];

        // Copy original event properties over to the new event
        orig = event.originalEvent;
        if ( orig ) {
          for ( prop in orig ) {
            if ( !( prop in event ) ) {
              event[ prop ] = orig[ prop ];
            }
          }
        }

        this.element.trigger( event, data );
        return !( $.isFunction( callback ) &&
            callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
            event.isDefaultPrevented() );
      }
    };

    $.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
      $.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
        if ( typeof options === "string" ) {
          options = { effect: options };
        }

        var hasOptions;
        var effectName = !options ?
            method :
            options === true || typeof options === "number" ?
                defaultEffect :
                options.effect || defaultEffect;

        options = options || {};
        if ( typeof options === "number" ) {
          options = { duration: options };
        }

        hasOptions = !$.isEmptyObject( options );
        options.complete = callback;

        if ( options.delay ) {
          element.delay( options.delay );
        }

        if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
          element[ method ]( options );
        } else if ( effectName !== method && element[ effectName ] ) {
          element[ effectName ]( options.duration, options.easing, callback );
        } else {
          element.queue( function( next ) {
            $( this )[ method ]();
            if ( callback ) {
              callback.call( element[ 0 ] );
            }
            next();
          } );
        }
      };
    } );

    var widget = $.widget;


    /*!
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: http://api.jqueryui.com/position/
//>>demos: http://jqueryui.com/position/


    ( function() {
      var cachedScrollbarWidth,
          max = Math.max,
          abs = Math.abs,
          rhorizontal = /left|center|right/,
          rvertical = /top|center|bottom/,
          roffset = /[\+\-]\d+(\.[\d]+)?%?/,
          rposition = /^\w+/,
          rpercent = /%$/,
          _position = $.fn.position;

      function getOffsets( offsets, width, height ) {
        return [
          parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
          parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
        ];
      }

      function parseCss( element, property ) {
        return parseInt( $.css( element, property ), 10 ) || 0;
      }

      function getDimensions( elem ) {
        var raw = elem[ 0 ];
        if ( raw.nodeType === 9 ) {
          return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: 0, left: 0 }
          };
        }
        if ( $.isWindow( raw ) ) {
          return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
          };
        }
        if ( raw.preventDefault ) {
          return {
            width: 0,
            height: 0,
            offset: { top: raw.pageY, left: raw.pageX }
          };
        }
        return {
          width: elem.outerWidth(),
          height: elem.outerHeight(),
          offset: elem.offset()
        };
      }

      $.position = {
        scrollbarWidth: function() {
          if ( cachedScrollbarWidth !== undefined ) {
            return cachedScrollbarWidth;
          }
          var w1, w2,
              div = $( "<div " +
                  "style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
                  "<div style='height:100px;width:auto;'></div></div>" ),
              innerDiv = div.children()[ 0 ];

          $( "body" ).append( div );
          w1 = innerDiv.offsetWidth;
          div.css( "overflow", "scroll" );

          w2 = innerDiv.offsetWidth;

          if ( w1 === w2 ) {
            w2 = div[ 0 ].clientWidth;
          }

          div.remove();

          return ( cachedScrollbarWidth = w1 - w2 );
        },
        getScrollInfo: function( within ) {
          var overflowX = within.isWindow || within.isDocument ? "" :
              within.element.css( "overflow-x" ),
              overflowY = within.isWindow || within.isDocument ? "" :
                  within.element.css( "overflow-y" ),
              hasOverflowX = overflowX === "scroll" ||
                  ( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
              hasOverflowY = overflowY === "scroll" ||
                  ( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
          return {
            width: hasOverflowY ? $.position.scrollbarWidth() : 0,
            height: hasOverflowX ? $.position.scrollbarWidth() : 0
          };
        },
        getWithinInfo: function( element ) {
          var withinElement = $( element || window ),
              isWindow = $.isWindow( withinElement[ 0 ] ),
              isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
              hasOffset = !isWindow && !isDocument;
          return {
            element: withinElement,
            isWindow: isWindow,
            isDocument: isDocument,
            offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
            scrollLeft: withinElement.scrollLeft(),
            scrollTop: withinElement.scrollTop(),
            width: withinElement.outerWidth(),
            height: withinElement.outerHeight()
          };
        }
      };

      $.fn.position = function( options ) {
        if ( !options || !options.of ) {
          return _position.apply( this, arguments );
        }

        // Make a copy, we don't want to modify arguments
        options = $.extend( {}, options );

        var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
            target = $( options.of ),
            within = $.position.getWithinInfo( options.within ),
            scrollInfo = $.position.getScrollInfo( within ),
            collision = ( options.collision || "flip" ).split( " " ),
            offsets = {};

        dimensions = getDimensions( target );
        if ( target[ 0 ].preventDefault ) {

          // Force left top to allow flipping
          options.at = "left top";
        }
        targetWidth = dimensions.width;
        targetHeight = dimensions.height;
        targetOffset = dimensions.offset;

        // Clone to reuse original targetOffset later
        basePosition = $.extend( {}, targetOffset );

        // Force my and at to have valid horizontal and vertical positions
        // if a value is missing or invalid, it will be converted to center
        $.each( [ "my", "at" ], function() {
          var pos = ( options[ this ] || "" ).split( " " ),
              horizontalOffset,
              verticalOffset;

          if ( pos.length === 1 ) {
            pos = rhorizontal.test( pos[ 0 ] ) ?
                pos.concat( [ "center" ] ) :
                rvertical.test( pos[ 0 ] ) ?
                    [ "center" ].concat( pos ) :
                    [ "center", "center" ];
          }
          pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
          pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

          // Calculate offsets
          horizontalOffset = roffset.exec( pos[ 0 ] );
          verticalOffset = roffset.exec( pos[ 1 ] );
          offsets[ this ] = [
            horizontalOffset ? horizontalOffset[ 0 ] : 0,
            verticalOffset ? verticalOffset[ 0 ] : 0
          ];

          // Reduce to just the positions without the offsets
          options[ this ] = [
            rposition.exec( pos[ 0 ] )[ 0 ],
            rposition.exec( pos[ 1 ] )[ 0 ]
          ];
        } );

        // Normalize collision option
        if ( collision.length === 1 ) {
          collision[ 1 ] = collision[ 0 ];
        }

        if ( options.at[ 0 ] === "right" ) {
          basePosition.left += targetWidth;
        } else if ( options.at[ 0 ] === "center" ) {
          basePosition.left += targetWidth / 2;
        }

        if ( options.at[ 1 ] === "bottom" ) {
          basePosition.top += targetHeight;
        } else if ( options.at[ 1 ] === "center" ) {
          basePosition.top += targetHeight / 2;
        }

        atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
        basePosition.left += atOffset[ 0 ];
        basePosition.top += atOffset[ 1 ];

        return this.each( function() {
          var collisionPosition, using,
              elem = $( this ),
              elemWidth = elem.outerWidth(),
              elemHeight = elem.outerHeight(),
              marginLeft = parseCss( this, "marginLeft" ),
              marginTop = parseCss( this, "marginTop" ),
              collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
                  scrollInfo.width,
              collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
                  scrollInfo.height,
              position = $.extend( {}, basePosition ),
              myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

          if ( options.my[ 0 ] === "right" ) {
            position.left -= elemWidth;
          } else if ( options.my[ 0 ] === "center" ) {
            position.left -= elemWidth / 2;
          }

          if ( options.my[ 1 ] === "bottom" ) {
            position.top -= elemHeight;
          } else if ( options.my[ 1 ] === "center" ) {
            position.top -= elemHeight / 2;
          }

          position.left += myOffset[ 0 ];
          position.top += myOffset[ 1 ];

          collisionPosition = {
            marginLeft: marginLeft,
            marginTop: marginTop
          };

          $.each( [ "left", "top" ], function( i, dir ) {
            if ( $.ui.position[ collision[ i ] ] ) {
              $.ui.position[ collision[ i ] ][ dir ]( position, {
                targetWidth: targetWidth,
                targetHeight: targetHeight,
                elemWidth: elemWidth,
                elemHeight: elemHeight,
                collisionPosition: collisionPosition,
                collisionWidth: collisionWidth,
                collisionHeight: collisionHeight,
                offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
                my: options.my,
                at: options.at,
                within: within,
                elem: elem
              } );
            }
          } );

          if ( options.using ) {

            // Adds feedback as second argument to using callback, if present
            using = function( props ) {
              var left = targetOffset.left - position.left,
                  right = left + targetWidth - elemWidth,
                  top = targetOffset.top - position.top,
                  bottom = top + targetHeight - elemHeight,
                  feedback = {
                    target: {
                      element: target,
                      left: targetOffset.left,
                      top: targetOffset.top,
                      width: targetWidth,
                      height: targetHeight
                    },
                    element: {
                      element: elem,
                      left: position.left,
                      top: position.top,
                      width: elemWidth,
                      height: elemHeight
                    },
                    horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                    vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                  };
              if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
                feedback.horizontal = "center";
              }
              if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
                feedback.vertical = "middle";
              }
              if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
                feedback.important = "horizontal";
              } else {
                feedback.important = "vertical";
              }
              options.using.call( this, props, feedback );
            };
          }

          elem.offset( $.extend( position, { using: using } ) );
        } );
      };

      $.ui.position = {
        fit: {
          left: function( position, data ) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
                outerWidth = within.width,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = withinOffset - collisionPosLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
                newOverRight;

            // Element is wider than within
            if ( data.collisionWidth > outerWidth ) {

              // Element is initially over the left side of within
              if ( overLeft > 0 && overRight <= 0 ) {
                newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
                    withinOffset;
                position.left += overLeft - newOverRight;

                // Element is initially over right side of within
              } else if ( overRight > 0 && overLeft <= 0 ) {
                position.left = withinOffset;

                // Element is initially over both left and right sides of within
              } else {
                if ( overLeft > overRight ) {
                  position.left = withinOffset + outerWidth - data.collisionWidth;
                } else {
                  position.left = withinOffset;
                }
              }

              // Too far left -> align with left edge
            } else if ( overLeft > 0 ) {
              position.left += overLeft;

              // Too far right -> align with right edge
            } else if ( overRight > 0 ) {
              position.left -= overRight;

              // Adjust based on position and margin
            } else {
              position.left = max( position.left - collisionPosLeft, position.left );
            }
          },
          top: function( position, data ) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
                outerHeight = data.within.height,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = withinOffset - collisionPosTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
                newOverBottom;

            // Element is taller than within
            if ( data.collisionHeight > outerHeight ) {

              // Element is initially over the top of within
              if ( overTop > 0 && overBottom <= 0 ) {
                newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
                    withinOffset;
                position.top += overTop - newOverBottom;

                // Element is initially over bottom of within
              } else if ( overBottom > 0 && overTop <= 0 ) {
                position.top = withinOffset;

                // Element is initially over both top and bottom of within
              } else {
                if ( overTop > overBottom ) {
                  position.top = withinOffset + outerHeight - data.collisionHeight;
                } else {
                  position.top = withinOffset;
                }
              }

              // Too far up -> align with top
            } else if ( overTop > 0 ) {
              position.top += overTop;

              // Too far down -> align with bottom edge
            } else if ( overBottom > 0 ) {
              position.top -= overBottom;

              // Adjust based on position and margin
            } else {
              position.top = max( position.top - collisionPosTop, position.top );
            }
          }
        },
        flip: {
          left: function( position, data ) {
            var within = data.within,
                withinOffset = within.offset.left + within.scrollLeft,
                outerWidth = within.width,
                offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = collisionPosLeft - offsetLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
                myOffset = data.my[ 0 ] === "left" ?
                    -data.elemWidth :
                    data.my[ 0 ] === "right" ?
                        data.elemWidth :
                        0,
                atOffset = data.at[ 0 ] === "left" ?
                    data.targetWidth :
                    data.at[ 0 ] === "right" ?
                        -data.targetWidth :
                        0,
                offset = -2 * data.offset[ 0 ],
                newOverRight,
                newOverLeft;

            if ( overLeft < 0 ) {
              newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
                  outerWidth - withinOffset;
              if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
                position.left += myOffset + atOffset + offset;
              }
            } else if ( overRight > 0 ) {
              newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
                  atOffset + offset - offsetLeft;
              if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
                position.left += myOffset + atOffset + offset;
              }
            }
          },
          top: function( position, data ) {
            var within = data.within,
                withinOffset = within.offset.top + within.scrollTop,
                outerHeight = within.height,
                offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = collisionPosTop - offsetTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
                top = data.my[ 1 ] === "top",
                myOffset = top ?
                    -data.elemHeight :
                    data.my[ 1 ] === "bottom" ?
                        data.elemHeight :
                        0,
                atOffset = data.at[ 1 ] === "top" ?
                    data.targetHeight :
                    data.at[ 1 ] === "bottom" ?
                        -data.targetHeight :
                        0,
                offset = -2 * data.offset[ 1 ],
                newOverTop,
                newOverBottom;
            if ( overTop < 0 ) {
              newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
                  outerHeight - withinOffset;
              if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
                position.top += myOffset + atOffset + offset;
              }
            } else if ( overBottom > 0 ) {
              newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
                  offset - offsetTop;
              if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
                position.top += myOffset + atOffset + offset;
              }
            }
          }
        },
        flipfit: {
          left: function() {
            $.ui.position.flip.left.apply( this, arguments );
            $.ui.position.fit.left.apply( this, arguments );
          },
          top: function() {
            $.ui.position.flip.top.apply( this, arguments );
            $.ui.position.fit.top.apply( this, arguments );
          }
        }
      };

    } )();

    var position = $.ui.position;


    /*!
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: http://api.jqueryui.com/data-selector/


    var data = $.extend( $.expr[ ":" ], {
      data: $.expr.createPseudo ?
          $.expr.createPseudo( function( dataName ) {
            return function( elem ) {
              return !!$.data( elem, dataName );
            };
          } ) :

          // Support: jQuery <1.8
          function( elem, i, match ) {
            return !!$.data( elem, match[ 3 ] );
          }
    } );

    /*!
 * jQuery UI Disable Selection 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: disableSelection
//>>group: Core
//>>description: Disable selection of text content within the set of matched elements.
//>>docs: http://api.jqueryui.com/disableSelection/

// This file is deprecated


    var disableSelection = $.fn.extend( {
      disableSelection: ( function() {
        var eventType = "onselectstart" in document.createElement( "div" ) ?
            "selectstart" :
            "mousedown";

        return function() {
          return this.on( eventType + ".ui-disableSelection", function( event ) {
            event.preventDefault();
          } );
        };
      } )(),

      enableSelection: function() {
        return this.off( ".ui-disableSelection" );
      }
    } );


    /*!
 * jQuery UI Focusable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :focusable Selector
//>>group: Core
//>>description: Selects elements which can be focused.
//>>docs: http://api.jqueryui.com/focusable-selector/



// Selectors
    $.ui.focusable = function( element, hasTabindex ) {
      var map, mapName, img, focusableIfVisible, fieldset,
          nodeName = element.nodeName.toLowerCase();

      if ( "area" === nodeName ) {
        map = element.parentNode;
        mapName = map.name;
        if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
          return false;
        }
        img = $( "img[usemap='#" + mapName + "']" );
        return img.length > 0 && img.is( ":visible" );
      }

      if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
        focusableIfVisible = !element.disabled;

        if ( focusableIfVisible ) {

          // Form controls within a disabled fieldset are disabled.
          // However, controls within the fieldset's legend do not get disabled.
          // Since controls generally aren't placed inside legends, we skip
          // this portion of the check.
          fieldset = $( element ).closest( "fieldset" )[ 0 ];
          if ( fieldset ) {
            focusableIfVisible = !fieldset.disabled;
          }
        }
      } else if ( "a" === nodeName ) {
        focusableIfVisible = element.href || hasTabindex;
      } else {
        focusableIfVisible = hasTabindex;
      }

      return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
    };

// Support: IE 8 only
// IE 8 doesn't resolve inherit to visible/hidden for computed values
    function visible( element ) {
      var visibility = element.css( "visibility" );
      while ( visibility === "inherit" ) {
        element = element.parent();
        visibility = element.css( "visibility" );
      }
      return visibility !== "hidden";
    }

    $.extend( $.expr[ ":" ], {
      focusable: function( element ) {
        return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
      }
    } );

    var focusable = $.ui.focusable;




// Support: IE8 Only
// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
// with a string, so we need to find the proper form.
    var form = $.fn.form = function() {
      return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
    };


    /*!
 * jQuery UI Form Reset Mixin 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Form Reset Mixin
//>>group: Core
//>>description: Refresh input widgets when their form is reset
//>>docs: http://api.jqueryui.com/form-reset-mixin/



    var formResetMixin = $.ui.formResetMixin = {
      _formResetHandler: function() {
        var form = $( this );

        // Wait for the form reset to actually happen before refreshing
        setTimeout( function() {
          var instances = form.data( "ui-form-reset-instances" );
          $.each( instances, function() {
            this.refresh();
          } );
        } );
      },

      _bindFormResetHandler: function() {
        this.form = this.element.form();
        if ( !this.form.length ) {
          return;
        }

        var instances = this.form.data( "ui-form-reset-instances" ) || [];
        if ( !instances.length ) {

          // We don't use _on() here because we use a single event handler per form
          this.form.on( "reset.ui-form-reset", this._formResetHandler );
        }
        instances.push( this );
        this.form.data( "ui-form-reset-instances", instances );
      },

      _unbindFormResetHandler: function() {
        if ( !this.form.length ) {
          return;
        }

        var instances = this.form.data( "ui-form-reset-instances" );
        instances.splice( $.inArray( this, instances ), 1 );
        if ( instances.length ) {
          this.form.data( "ui-form-reset-instances", instances );
        } else {
          this.form
              .removeData( "ui-form-reset-instances" )
              .off( "reset.ui-form-reset" );
        }
      }
    };


    /*!
 * jQuery UI Support for jQuery core 1.7.x 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 */

//>>label: jQuery 1.7 Support
//>>group: Core
//>>description: Support version 1.7.x of jQuery core



// Support: jQuery 1.7 only
// Not a great way to check versions, but since we only support 1.7+ and only
// need to detect <1.8, this is a simple check that should suffice. Checking
// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
// 1.7 anymore). See #11197 for why we're not using feature detection.
    if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {

      // Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
      // Unlike jQuery Core 1.8+, these only support numeric values to set the
      // dimensions in pixels
      $.each( [ "Width", "Height" ], function( i, name ) {
        var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
            type = name.toLowerCase(),
            orig = {
              innerWidth: $.fn.innerWidth,
              innerHeight: $.fn.innerHeight,
              outerWidth: $.fn.outerWidth,
              outerHeight: $.fn.outerHeight
            };

        function reduce( elem, size, border, margin ) {
          $.each( side, function() {
            size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
            if ( border ) {
              size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
            }
            if ( margin ) {
              size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
            }
          } );
          return size;
        }

        $.fn[ "inner" + name ] = function( size ) {
          if ( size === undefined ) {
            return orig[ "inner" + name ].call( this );
          }

          return this.each( function() {
            $( this ).css( type, reduce( this, size ) + "px" );
          } );
        };

        $.fn[ "outer" + name ] = function( size, margin ) {
          if ( typeof size !== "number" ) {
            return orig[ "outer" + name ].call( this, size );
          }

          return this.each( function() {
            $( this ).css( type, reduce( this, size, true, margin ) + "px" );
          } );
        };
      } );

      $.fn.addBack = function( selector ) {
        return this.add( selector == null ?
            this.prevObject : this.prevObject.filter( selector )
        );
      };
    }

    ;
    /*!
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/


    var keycode = $.ui.keyCode = {
      BACKSPACE: 8,
      COMMA: 188,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      LEFT: 37,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      PERIOD: 190,
      RIGHT: 39,
      SPACE: 32,
      TAB: 9,
      UP: 38
    };




// Internal use only
    var escapeSelector = $.ui.escapeSelector = ( function() {
      var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
      return function( selector ) {
        return selector.replace( selectorEscape, "\\$1" );
      };
    } )();


    /*!
 * jQuery UI Labels 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: labels
//>>group: Core
//>>description: Find all the labels associated with a given input
//>>docs: http://api.jqueryui.com/labels/



    var labels = $.fn.labels = function() {
      var ancestor, selector, id, labels, ancestors;

      // Check control.labels first
      if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
        return this.pushStack( this[ 0 ].labels );
      }

      // Support: IE <= 11, FF <= 37, Android <= 2.3 only
      // Above browsers do not support control.labels. Everything below is to support them
      // as well as document fragments. control.labels does not work on document fragments
      labels = this.eq( 0 ).parents( "label" );

      // Look for the label based on the id
      id = this.attr( "id" );
      if ( id ) {

        // We don't search against the document in case the element
        // is disconnected from the DOM
        ancestor = this.eq( 0 ).parents().last();

        // Get a full set of top level ancestors
        ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

        // Create a selector for the label based on the id
        selector = "label[for='" + $.ui.escapeSelector( id ) + "']";

        labels = labels.add( ancestors.find( selector ).addBack( selector ) );

      }

      // Return whatever we have found for labels
      return this.pushStack( labels );
    };


    /*!
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: http://api.jqueryui.com/scrollParent/



    var scrollParent = $.fn.scrollParent = function( includeHidden ) {
      var position = this.css( "position" ),
          excludeStaticParent = position === "absolute",
          overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
          scrollParent = this.parents().filter( function() {
            var parent = $( this );
            if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
              return false;
            }
            return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
                parent.css( "overflow-x" ) );
          } ).eq( 0 );

      return position === "fixed" || !scrollParent.length ?
          $( this[ 0 ].ownerDocument || document ) :
          scrollParent;
    };


    /*!
 * jQuery UI Tabbable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :tabbable Selector
//>>group: Core
//>>description: Selects elements which can be tabbed to.
//>>docs: http://api.jqueryui.com/tabbable-selector/



    var tabbable = $.extend( $.expr[ ":" ], {
      tabbable: function( element ) {
        var tabIndex = $.attr( element, "tabindex" ),
            hasTabindex = tabIndex != null;
        return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
      }
    } );


    /*!
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/



    var uniqueId = $.fn.extend( {
      uniqueId: ( function() {
        var uuid = 0;

        return function() {
          return this.each( function() {
            if ( !this.id ) {
              this.id = "ui-id-" + ( ++uuid );
            }
          } );
        };
      } )(),

      removeUniqueId: function() {
        return this.each( function() {
          if ( /^ui-id-\d+$/.test( this.id ) ) {
            $( this ).removeAttr( "id" );
          }
        } );
      }
    } );



    var safeActiveElement = $.ui.safeActiveElement = function( document ) {
      var activeElement;

      // Support: IE 9 only
      // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
      try {
        activeElement = document.activeElement;
      } catch ( error ) {
        activeElement = document.body;
      }

      // Support: IE 9 - 11 only
      // IE may return null instead of an element
      // Interestingly, this only seems to occur when NOT in an iframe
      if ( !activeElement ) {
        activeElement = document.body;
      }

      // Support: IE 11 only
      // IE11 returns a seemingly empty object in some cases when accessing
      // document.activeElement from an <iframe>
      if ( !activeElement.nodeName ) {
        activeElement = document.body;
      }

      return activeElement;
    };


    /*!
 * jQuery UI Tabs 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: http://api.jqueryui.com/tabs/
//>>demos: http://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css



    $.widget( "ui.tabs", {
      version: "1.12.1",
      delay: 300,
      options: {
        active: null,
        classes: {
          "ui-tabs": "ui-corner-all",
          "ui-tabs-nav": "ui-corner-all",
          "ui-tabs-panel": "ui-corner-bottom",
          "ui-tabs-tab": "ui-corner-top"
        },
        collapsible: false,
        event: "click",
        heightStyle: "content",
        hide: null,
        show: null,

        // Callbacks
        activate: null,
        beforeActivate: null,
        beforeLoad: null,
        load: null
      },

      _isLocal: ( function() {
        var rhash = /#.*$/;

        return function( anchor ) {
          var anchorUrl, locationUrl;

          anchorUrl = anchor.href.replace( rhash, "" );
          locationUrl = location.href.replace( rhash, "" );

          // Decoding may throw an error if the URL isn't UTF-8 (#9518)
          try {
            anchorUrl = decodeURIComponent( anchorUrl );
          } catch ( error ) {}
          try {
            locationUrl = decodeURIComponent( locationUrl );
          } catch ( error ) {}

          return anchor.hash.length > 1 && anchorUrl === locationUrl;
        };
      } )(),

      _create: function() {
        var that = this,
            options = this.options;

        this.running = false;

        this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
        this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

        this._processTabs();
        options.active = this._initialActive();

        // Take disabling tabs via class attribute from HTML
        // into account and update option properly.
        if ( $.isArray( options.disabled ) ) {
          options.disabled = $.unique( options.disabled.concat(
              $.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
                return that.tabs.index( li );
              } )
          ) ).sort();
        }

        // Check for length avoids error when initializing empty list
        if ( this.options.active !== false && this.anchors.length ) {
          this.active = this._findActive( options.active );
        } else {
          this.active = $();
        }

        this._refresh();

        if ( this.active.length ) {
          this.load( options.active );
        }
      },

      _initialActive: function() {
        var active = this.options.active,
            collapsible = this.options.collapsible,
            locationHash = location.hash.substring( 1 );

        if ( active === null ) {

          // check the fragment identifier in the URL
          if ( locationHash ) {
            this.tabs.each( function( i, tab ) {
              if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
                active = i;
                return false;
              }
            } );
          }

          // Check for a tab marked active via a class
          if ( active === null ) {
            active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
          }

          // No active tab, set to false
          if ( active === null || active === -1 ) {
            active = this.tabs.length ? 0 : false;
          }
        }

        // Handle numbers: negative, out of range
        if ( active !== false ) {
          active = this.tabs.index( this.tabs.eq( active ) );
          if ( active === -1 ) {
            active = collapsible ? false : 0;
          }
        }

        // Don't allow collapsible: false and active: false
        if ( !collapsible && active === false && this.anchors.length ) {
          active = 0;
        }

        return active;
      },

      _getCreateEventData: function() {
        return {
          tab: this.active,
          panel: !this.active.length ? $() : this._getPanelForTab( this.active )
        };
      },

      _tabKeydown: function( event ) {
        var focusedTab = $( $.ui.safeActiveElement( this.document[ 0 ] ) ).closest( "li" ),
            selectedIndex = this.tabs.index( focusedTab ),
            goingForward = true;

        if ( this._handlePageNav( event ) ) {
          return;
        }

        switch ( event.keyCode ) {
          case $.ui.keyCode.RIGHT:
          case $.ui.keyCode.DOWN:
            selectedIndex++;
            break;
          case $.ui.keyCode.UP:
          case $.ui.keyCode.LEFT:
            goingForward = false;
            selectedIndex--;
            break;
          case $.ui.keyCode.END:
            selectedIndex = this.anchors.length - 1;
            break;
          case $.ui.keyCode.HOME:
            selectedIndex = 0;
            break;
          case $.ui.keyCode.SPACE:

            // Activate only, no collapsing
            event.preventDefault();
            clearTimeout( this.activating );
            this._activate( selectedIndex );
            return;
          case $.ui.keyCode.ENTER:

            // Toggle (cancel delayed activation, allow collapsing)
            event.preventDefault();
            clearTimeout( this.activating );

            // Determine if we should collapse or activate
            this._activate( selectedIndex === this.options.active ? false : selectedIndex );
            return;
          default:
            return;
        }

        // Focus the appropriate tab, based on which key was pressed
        event.preventDefault();
        clearTimeout( this.activating );
        selectedIndex = this._focusNextTab( selectedIndex, goingForward );

        // Navigating with control/command key will prevent automatic activation
        if ( !event.ctrlKey && !event.metaKey ) {

          // Update aria-selected immediately so that AT think the tab is already selected.
          // Otherwise AT may confuse the user by stating that they need to activate the tab,
          // but the tab will already be activated by the time the announcement finishes.
          focusedTab.attr( "aria-selected", "false" );
          this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

          this.activating = this._delay( function() {
            this.option( "active", selectedIndex );
          }, this.delay );
        }
      },

      _panelKeydown: function( event ) {
        if ( this._handlePageNav( event ) ) {
          return;
        }

        // Ctrl+up moves focus to the current tab
        if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
          event.preventDefault();
          this.active.trigger( "focus" );
        }
      },

      // Alt+page up/down moves focus to the previous/next tab (and activates)
      _handlePageNav: function( event ) {
        if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
          this._activate( this._focusNextTab( this.options.active - 1, false ) );
          return true;
        }
        if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
          this._activate( this._focusNextTab( this.options.active + 1, true ) );
          return true;
        }
      },

      _findNextTab: function( index, goingForward ) {
        var lastTabIndex = this.tabs.length - 1;

        function constrain() {
          if ( index > lastTabIndex ) {
            index = 0;
          }
          if ( index < 0 ) {
            index = lastTabIndex;
          }
          return index;
        }

        while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
          index = goingForward ? index + 1 : index - 1;
        }

        return index;
      },

      _focusNextTab: function( index, goingForward ) {
        index = this._findNextTab( index, goingForward );
        this.tabs.eq( index ).trigger( "focus" );
        return index;
      },

      _setOption: function( key, value ) {
        if ( key === "active" ) {

          // _activate() will handle invalid values and update this.options
          this._activate( value );
          return;
        }

        this._super( key, value );

        if ( key === "collapsible" ) {
          this._toggleClass( "ui-tabs-collapsible", null, value );

          // Setting collapsible: false while collapsed; open first panel
          if ( !value && this.options.active === false ) {
            this._activate( 0 );
          }
        }

        if ( key === "event" ) {
          this._setupEvents( value );
        }

        if ( key === "heightStyle" ) {
          this._setupHeightStyle( value );
        }
      },

      _sanitizeSelector: function( hash ) {
        return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
      },

      refresh: function() {
        var options = this.options,
            lis = this.tablist.children( ":has(a[href])" );

        // Get disabled tabs from class attribute from HTML
        // this will get converted to a boolean if needed in _refresh()
        options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
          return lis.index( tab );
        } );

        this._processTabs();

        // Was collapsed or no tabs
        if ( options.active === false || !this.anchors.length ) {
          options.active = false;
          this.active = $();

          // was active, but active tab is gone
        } else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

          // all remaining tabs are disabled
          if ( this.tabs.length === options.disabled.length ) {
            options.active = false;
            this.active = $();

            // activate previous tab
          } else {
            this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
          }

          // was active, active tab still exists
        } else {

          // make sure active index is correct
          options.active = this.tabs.index( this.active );
        }

        this._refresh();
      },

      _refresh: function() {
        this._setOptionDisabled( this.options.disabled );
        this._setupEvents( this.options.event );
        this._setupHeightStyle( this.options.heightStyle );

        this.tabs.not( this.active ).attr( {
          "aria-selected": "false",
          "aria-expanded": "false",
          tabIndex: -1
        } );
        this.panels.not( this._getPanelForTab( this.active ) )
            .hide()
            .attr( {
              "aria-hidden": "true"
            } );

        // Make sure one tab is in the tab order
        if ( !this.active.length ) {
          this.tabs.eq( 0 ).attr( "tabIndex", 0 );
        } else {
          this.active
              .attr( {
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
              } );
          this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
          this._getPanelForTab( this.active )
              .show()
              .attr( {
                "aria-hidden": "false"
              } );
        }
      },

      _processTabs: function() {
        var that = this,
            prevTabs = this.tabs,
            prevAnchors = this.anchors,
            prevPanels = this.panels;

        this.tablist = this._getList().attr( "role", "tablist" );
        this._addClass( this.tablist, "ui-tabs-nav",
            "ui-helper-reset ui-helper-clearfix ui-widget-header" );

        // Prevent users from focusing disabled tabs via click
        this.tablist
            .on( "mousedown" + this.eventNamespace, "> li", function( event ) {
              if ( $( this ).is( ".ui-state-disabled" ) ) {
                event.preventDefault();
              }
            } )

            // Support: IE <9
            // Preventing the default action in mousedown doesn't prevent IE
            // from focusing the element, so if the anchor gets focused, blur.
            // We don't have to worry about focusing the previously focused
            // element since clicking on a non-focusable element should focus
            // the body anyway.
            .on( "focus" + this.eventNamespace, ".ui-tabs-anchor", function() {
              if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
                this.blur();
              }
            } );

        this.tabs = this.tablist.find( "> li:has(a[href])" )
            .attr( {
              role: "tab",
              tabIndex: -1
            } );
        this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

        this.anchors = this.tabs.map( function() {
          return $( "a", this )[ 0 ];
        } )
            .attr( {
              role: "presentation",
              tabIndex: -1
            } );
        this._addClass( this.anchors, "ui-tabs-anchor" );

        this.panels = $();

        this.anchors.each( function( i, anchor ) {
          var selector, panel, panelId,
              anchorId = $( anchor ).uniqueId().attr( "id" ),
              tab = $( anchor ).closest( "li" ),
              originalAriaControls = tab.attr( "aria-controls" );

          // Inline tab
          if ( that._isLocal( anchor ) ) {
            selector = anchor.hash;
            panelId = selector.substring( 1 );
            panel = that.element.find( that._sanitizeSelector( selector ) );

            // remote tab
          } else {

            // If the tab doesn't already have aria-controls,
            // generate an id by using a throw-away element
            panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
            selector = "#" + panelId;
            panel = that.element.find( selector );
            if ( !panel.length ) {
              panel = that._createPanel( panelId );
              panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
            }
            panel.attr( "aria-live", "polite" );
          }

          if ( panel.length ) {
            that.panels = that.panels.add( panel );
          }
          if ( originalAriaControls ) {
            tab.data( "ui-tabs-aria-controls", originalAriaControls );
          }
          tab.attr( {
            "aria-controls": panelId,
            "aria-labelledby": anchorId
          } );
          panel.attr( "aria-labelledby", anchorId );
        } );

        this.panels.attr( "role", "tabpanel" );
        this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

        // Avoid memory leaks (#10056)
        if ( prevTabs ) {
          this._off( prevTabs.not( this.tabs ) );
          this._off( prevAnchors.not( this.anchors ) );
          this._off( prevPanels.not( this.panels ) );
        }
      },

      // Allow overriding how to find the list for rare usage scenarios (#7715)
      _getList: function() {
        return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
      },

      _createPanel: function( id ) {
        return $( "<div>" )
            .attr( "id", id )
            .data( "ui-tabs-destroy", true );
      },

      _setOptionDisabled: function( disabled ) {
        var currentItem, li, i;

        if ( $.isArray( disabled ) ) {
          if ( !disabled.length ) {
            disabled = false;
          } else if ( disabled.length === this.anchors.length ) {
            disabled = true;
          }
        }

        // Disable tabs
        for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
          currentItem = $( li );
          if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
            currentItem.attr( "aria-disabled", "true" );
            this._addClass( currentItem, null, "ui-state-disabled" );
          } else {
            currentItem.removeAttr( "aria-disabled" );
            this._removeClass( currentItem, null, "ui-state-disabled" );
          }
        }

        this.options.disabled = disabled;

        this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
            disabled === true );
      },

      _setupEvents: function( event ) {
        var events = {};
        if ( event ) {
          $.each( event.split( " " ), function( index, eventName ) {
            events[ eventName ] = "_eventHandler";
          } );
        }

        this._off( this.anchors.add( this.tabs ).add( this.panels ) );

        // Always prevent the default action, even when disabled
        this._on( true, this.anchors, {
          click: function( event ) {
            event.preventDefault();
          }
        } );
        this._on( this.anchors, events );
        this._on( this.tabs, { keydown: "_tabKeydown" } );
        this._on( this.panels, { keydown: "_panelKeydown" } );

        this._focusable( this.tabs );
        this._hoverable( this.tabs );
      },

      _setupHeightStyle: function( heightStyle ) {
        var maxHeight,
            parent = this.element.parent();

        if ( heightStyle === "fill" ) {
          maxHeight = parent.height();
          maxHeight -= this.element.outerHeight() - this.element.height();

          this.element.siblings( ":visible" ).each( function() {
            var elem = $( this ),
                position = elem.css( "position" );

            if ( position === "absolute" || position === "fixed" ) {
              return;
            }
            maxHeight -= elem.outerHeight( true );
          } );

          this.element.children().not( this.panels ).each( function() {
            maxHeight -= $( this ).outerHeight( true );
          } );

          this.panels.each( function() {
            $( this ).height( Math.max( 0, maxHeight -
                $( this ).innerHeight() + $( this ).height() ) );
          } )
              .css( "overflow", "auto" );
        } else if ( heightStyle === "auto" ) {
          maxHeight = 0;
          this.panels.each( function() {
            maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
          } ).height( maxHeight );
        }
      },

      _eventHandler: function( event ) {
        var options = this.options,
            active = this.active,
            anchor = $( event.currentTarget ),
            tab = anchor.closest( "li" ),
            clickedIsActive = tab[ 0 ] === active[ 0 ],
            collapsing = clickedIsActive && options.collapsible,
            toShow = collapsing ? $() : this._getPanelForTab( tab ),
            toHide = !active.length ? $() : this._getPanelForTab( active ),
            eventData = {
              oldTab: active,
              oldPanel: toHide,
              newTab: collapsing ? $() : tab,
              newPanel: toShow
            };

        event.preventDefault();

        if ( tab.hasClass( "ui-state-disabled" ) ||

            // tab is already loading
            tab.hasClass( "ui-tabs-loading" ) ||

            // can't switch durning an animation
            this.running ||

            // click on active header, but not collapsible
            ( clickedIsActive && !options.collapsible ) ||

            // allow canceling activation
            ( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
          return;
        }

        options.active = collapsing ? false : this.tabs.index( tab );

        this.active = clickedIsActive ? $() : tab;
        if ( this.xhr ) {
          this.xhr.abort();
        }

        if ( !toHide.length && !toShow.length ) {
          $.error( "jQuery UI Tabs: Mismatching fragment identifier." );
        }

        if ( toShow.length ) {
          this.load( this.tabs.index( tab ), event );
        }
        this._toggle( event, eventData );
      },

      // Handles show/hide for selecting tabs
      _toggle: function( event, eventData ) {
        var that = this,
            toShow = eventData.newPanel,
            toHide = eventData.oldPanel;

        this.running = true;

        function complete() {
          that.running = false;
          that._trigger( "activate", event, eventData );
        }

        function show() {
          that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

          if ( toShow.length && that.options.show ) {
            that._show( toShow, that.options.show, complete );
          } else {
            toShow.show();
            complete();
          }
        }

        // Start out by hiding, then showing, then completing
        if ( toHide.length && this.options.hide ) {
          this._hide( toHide, this.options.hide, function() {
            that._removeClass( eventData.oldTab.closest( "li" ),
                "ui-tabs-active", "ui-state-active" );
            show();
          } );
        } else {
          this._removeClass( eventData.oldTab.closest( "li" ),
              "ui-tabs-active", "ui-state-active" );
          toHide.hide();
          show();
        }

        toHide.attr( "aria-hidden", "true" );
        eventData.oldTab.attr( {
          "aria-selected": "false",
          "aria-expanded": "false"
        } );

        // If we're switching tabs, remove the old tab from the tab order.
        // If we're opening from collapsed state, remove the previous tab from the tab order.
        // If we're collapsing, then keep the collapsing tab in the tab order.
        if ( toShow.length && toHide.length ) {
          eventData.oldTab.attr( "tabIndex", -1 );
        } else if ( toShow.length ) {
          this.tabs.filter( function() {
            return $( this ).attr( "tabIndex" ) === 0;
          } )
              .attr( "tabIndex", -1 );
        }

        toShow.attr( "aria-hidden", "false" );
        eventData.newTab.attr( {
          "aria-selected": "true",
          "aria-expanded": "true",
          tabIndex: 0
        } );
      },

      _activate: function( index ) {
        var anchor,
            active = this._findActive( index );

        // Trying to activate the already active panel
        if ( active[ 0 ] === this.active[ 0 ] ) {
          return;
        }

        // Trying to collapse, simulate a click on the current active header
        if ( !active.length ) {
          active = this.active;
        }

        anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
        this._eventHandler( {
          target: anchor,
          currentTarget: anchor,
          preventDefault: $.noop
        } );
      },

      _findActive: function( index ) {
        return index === false ? $() : this.tabs.eq( index );
      },

      _getIndex: function( index ) {

        // meta-function to give users option to provide a href string instead of a numerical index.
        if ( typeof index === "string" ) {
          index = this.anchors.index( this.anchors.filter( "[href$='" +
              $.ui.escapeSelector( index ) + "']" ) );
        }

        return index;
      },

      _destroy: function() {
        if ( this.xhr ) {
          this.xhr.abort();
        }

        this.tablist
            .removeAttr( "role" )
            .off( this.eventNamespace );

        this.anchors
            .removeAttr( "role tabIndex" )
            .removeUniqueId();

        this.tabs.add( this.panels ).each( function() {
          if ( $.data( this, "ui-tabs-destroy" ) ) {
            $( this ).remove();
          } else {
            $( this ).removeAttr( "role tabIndex " +
                "aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
          }
        } );

        this.tabs.each( function() {
          var li = $( this ),
              prev = li.data( "ui-tabs-aria-controls" );
          if ( prev ) {
            li
                .attr( "aria-controls", prev )
                .removeData( "ui-tabs-aria-controls" );
          } else {
            li.removeAttr( "aria-controls" );
          }
        } );

        this.panels.show();

        if ( this.options.heightStyle !== "content" ) {
          this.panels.css( "height", "" );
        }
      },

      enable: function( index ) {
        var disabled = this.options.disabled;
        if ( disabled === false ) {
          return;
        }

        if ( index === undefined ) {
          disabled = false;
        } else {
          index = this._getIndex( index );
          if ( $.isArray( disabled ) ) {
            disabled = $.map( disabled, function( num ) {
              return num !== index ? num : null;
            } );
          } else {
            disabled = $.map( this.tabs, function( li, num ) {
              return num !== index ? num : null;
            } );
          }
        }
        this._setOptionDisabled( disabled );
      },

      disable: function( index ) {
        var disabled = this.options.disabled;
        if ( disabled === true ) {
          return;
        }

        if ( index === undefined ) {
          disabled = true;
        } else {
          index = this._getIndex( index );
          if ( $.inArray( index, disabled ) !== -1 ) {
            return;
          }
          if ( $.isArray( disabled ) ) {
            disabled = $.merge( [ index ], disabled ).sort();
          } else {
            disabled = [ index ];
          }
        }
        this._setOptionDisabled( disabled );
      },

      load: function( index, event ) {
        index = this._getIndex( index );
        var that = this,
            tab = this.tabs.eq( index ),
            anchor = tab.find( ".ui-tabs-anchor" ),
            panel = this._getPanelForTab( tab ),
            eventData = {
              tab: tab,
              panel: panel
            },
            complete = function( jqXHR, status ) {
              if ( status === "abort" ) {
                that.panels.stop( false, true );
              }

              that._removeClass( tab, "ui-tabs-loading" );
              panel.removeAttr( "aria-busy" );

              if ( jqXHR === that.xhr ) {
                delete that.xhr;
              }
            };

        // Not remote
        if ( this._isLocal( anchor[ 0 ] ) ) {
          return;
        }

        this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

        // Support: jQuery <1.8
        // jQuery <1.8 returns false if the request is canceled in beforeSend,
        // but as of 1.8, $.ajax() always returns a jqXHR object.
        if ( this.xhr && this.xhr.statusText !== "canceled" ) {
          this._addClass( tab, "ui-tabs-loading" );
          panel.attr( "aria-busy", "true" );

          this.xhr
              .done( function( response, status, jqXHR ) {

                // support: jQuery <1.8
                // http://bugs.jquery.com/ticket/11778
                setTimeout( function() {
                  panel.html( response );
                  that._trigger( "load", event, eventData );

                  complete( jqXHR, status );
                }, 1 );
              } )
              .fail( function( jqXHR, status ) {

                // support: jQuery <1.8
                // http://bugs.jquery.com/ticket/11778
                setTimeout( function() {
                  complete( jqXHR, status );
                }, 1 );
              } );
        }
      },

      _ajaxSettings: function( anchor, event, eventData ) {
        var that = this;
        return {

          // Support: IE <11 only
          // Strip any hash that exists to prevent errors with the Ajax request
          url: anchor.attr( "href" ).replace( /#.*$/, "" ),
          beforeSend: function( jqXHR, settings ) {
            return that._trigger( "beforeLoad", event,
                $.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
          }
        };
      },

      _getPanelForTab: function( tab ) {
        var id = $( tab ).attr( "aria-controls" );
        return this.element.find( this._sanitizeSelector( "#" + id ) );
      }
    } );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
    if ( $.uiBackCompat !== false ) {

      // Backcompat for ui-tab class (now ui-tabs-tab)
      $.widget( "ui.tabs", $.ui.tabs, {
        _processTabs: function() {
          this._superApply( arguments );
          this._addClass( this.tabs, "ui-tab" );
        }
      } );
    }

    var widgetsTabs = $.ui.tabs;


    /*!
 * jQuery UI Effects 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/category/effects-core/
//>>demos: http://jqueryui.com/effect/



    var dataSpace = "ui-effects-",
        dataSpaceStyle = "ui-effects-style",
        dataSpaceAnimated = "ui-effects-animated",

        // Create a local jQuery because jQuery Color relies on it and the
        // global may not exist with AMD and a custom build (#10199)
        jQuery = $;

    $.effects = {
      effect: {}
    };

    /*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
    ( function( jQuery, undefined ) {

      var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
          "borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

          // Plusequals test for += 100 -= 100
          rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

          // A set of RE's that can match strings and generate color tuples.
          stringParsers = [ {
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function( execResult ) {
              return [
                execResult[ 1 ],
                execResult[ 2 ],
                execResult[ 3 ],
                execResult[ 4 ]
              ];
            }
          }, {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function( execResult ) {
              return [
                execResult[ 1 ] * 2.55,
                execResult[ 2 ] * 2.55,
                execResult[ 3 ] * 2.55,
                execResult[ 4 ]
              ];
            }
          }, {

            // This regex ignores A-F because it's compared against an already lowercased string
            re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
            parse: function( execResult ) {
              return [
                parseInt( execResult[ 1 ], 16 ),
                parseInt( execResult[ 2 ], 16 ),
                parseInt( execResult[ 3 ], 16 )
              ];
            }
          }, {

            // This regex ignores A-F because it's compared against an already lowercased string
            re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
            parse: function( execResult ) {
              return [
                parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
                parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
                parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
              ];
            }
          }, {
            re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            space: "hsla",
            parse: function( execResult ) {
              return [
                execResult[ 1 ],
                execResult[ 2 ] / 100,
                execResult[ 3 ] / 100,
                execResult[ 4 ]
              ];
            }
          } ],

          // JQuery.Color( )
          color = jQuery.Color = function( color, green, blue, alpha ) {
            return new jQuery.Color.fn.parse( color, green, blue, alpha );
          },
          spaces = {
            rgba: {
              props: {
                red: {
                  idx: 0,
                  type: "byte"
                },
                green: {
                  idx: 1,
                  type: "byte"
                },
                blue: {
                  idx: 2,
                  type: "byte"
                }
              }
            },

            hsla: {
              props: {
                hue: {
                  idx: 0,
                  type: "degrees"
                },
                saturation: {
                  idx: 1,
                  type: "percent"
                },
                lightness: {
                  idx: 2,
                  type: "percent"
                }
              }
            }
          },
          propTypes = {
            "byte": {
              floor: true,
              max: 255
            },
            "percent": {
              max: 1
            },
            "degrees": {
              mod: 360,
              floor: true
            }
          },
          support = color.support = {},

          // Element for support tests
          supportElem = jQuery( "<p>" )[ 0 ],

          // Colors = jQuery.Color.names
          colors,

          // Local aliases of functions called often
          each = jQuery.each;

// Determine rgba support immediately
      supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
      support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// Define cache name and alpha properties
// for rgba and hsla spaces
      each( spaces, function( spaceName, space ) {
        space.cache = "_" + spaceName;
        space.props.alpha = {
          idx: 3,
          type: "percent",
          def: 1
        };
      } );

      function clamp( value, prop, allowEmpty ) {
        var type = propTypes[ prop.type ] || {};

        if ( value == null ) {
          return ( allowEmpty || !prop.def ) ? null : prop.def;
        }

        // ~~ is an short way of doing floor for positive numbers
        value = type.floor ? ~~value : parseFloat( value );

        // IE will pass in empty strings as value for alpha,
        // which will hit this case
        if ( isNaN( value ) ) {
          return prop.def;
        }

        if ( type.mod ) {

          // We add mod before modding to make sure that negatives values
          // get converted properly: -10 -> 350
          return ( value + type.mod ) % type.mod;
        }

        // For now all property types without mod have min and max
        return 0 > value ? 0 : type.max < value ? type.max : value;
      }

      function stringParse( string ) {
        var inst = color(),
            rgba = inst._rgba = [];

        string = string.toLowerCase();

        each( stringParsers, function( i, parser ) {
          var parsed,
              match = parser.re.exec( string ),
              values = match && parser.parse( match ),
              spaceName = parser.space || "rgba";

          if ( values ) {
            parsed = inst[ spaceName ]( values );

            // If this was an rgba parse the assignment might happen twice
            // oh well....
            inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
            rgba = inst._rgba = parsed._rgba;

            // Exit each( stringParsers ) here because we matched
            return false;
          }
        } );

        // Found a stringParser that handled it
        if ( rgba.length ) {

          // If this came from a parsed string, force "transparent" when alpha is 0
          // chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
          if ( rgba.join() === "0,0,0,0" ) {
            jQuery.extend( rgba, colors.transparent );
          }
          return inst;
        }

        // Named colors
        return colors[ string ];
      }

      color.fn = jQuery.extend( color.prototype, {
        parse: function( red, green, blue, alpha ) {
          if ( red === undefined ) {
            this._rgba = [ null, null, null, null ];
            return this;
          }
          if ( red.jquery || red.nodeType ) {
            red = jQuery( red ).css( green );
            green = undefined;
          }

          var inst = this,
              type = jQuery.type( red ),
              rgba = this._rgba = [];

          // More than 1 argument specified - assume ( red, green, blue, alpha )
          if ( green !== undefined ) {
            red = [ red, green, blue, alpha ];
            type = "array";
          }

          if ( type === "string" ) {
            return this.parse( stringParse( red ) || colors._default );
          }

          if ( type === "array" ) {
            each( spaces.rgba.props, function( key, prop ) {
              rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
            } );
            return this;
          }

          if ( type === "object" ) {
            if ( red instanceof color ) {
              each( spaces, function( spaceName, space ) {
                if ( red[ space.cache ] ) {
                  inst[ space.cache ] = red[ space.cache ].slice();
                }
              } );
            } else {
              each( spaces, function( spaceName, space ) {
                var cache = space.cache;
                each( space.props, function( key, prop ) {

                  // If the cache doesn't exist, and we know how to convert
                  if ( !inst[ cache ] && space.to ) {

                    // If the value was null, we don't need to copy it
                    // if the key was alpha, we don't need to copy it either
                    if ( key === "alpha" || red[ key ] == null ) {
                      return;
                    }
                    inst[ cache ] = space.to( inst._rgba );
                  }

                  // This is the only case where we allow nulls for ALL properties.
                  // call clamp with alwaysAllowEmpty
                  inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
                } );

                // Everything defined but alpha?
                if ( inst[ cache ] &&
                    jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {

                  // Use the default of 1
                  inst[ cache ][ 3 ] = 1;
                  if ( space.from ) {
                    inst._rgba = space.from( inst[ cache ] );
                  }
                }
              } );
            }
            return this;
          }
        },
        is: function( compare ) {
          var is = color( compare ),
              same = true,
              inst = this;

          each( spaces, function( _, space ) {
            var localCache,
                isCache = is[ space.cache ];
            if ( isCache ) {
              localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
              each( space.props, function( _, prop ) {
                if ( isCache[ prop.idx ] != null ) {
                  same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
                  return same;
                }
              } );
            }
            return same;
          } );
          return same;
        },
        _space: function() {
          var used = [],
              inst = this;
          each( spaces, function( spaceName, space ) {
            if ( inst[ space.cache ] ) {
              used.push( spaceName );
            }
          } );
          return used.pop();
        },
        transition: function( other, distance ) {
          var end = color( other ),
              spaceName = end._space(),
              space = spaces[ spaceName ],
              startColor = this.alpha() === 0 ? color( "transparent" ) : this,
              start = startColor[ space.cache ] || space.to( startColor._rgba ),
              result = start.slice();

          end = end[ space.cache ];
          each( space.props, function( key, prop ) {
            var index = prop.idx,
                startValue = start[ index ],
                endValue = end[ index ],
                type = propTypes[ prop.type ] || {};

            // If null, don't override start value
            if ( endValue === null ) {
              return;
            }

            // If null - use end
            if ( startValue === null ) {
              result[ index ] = endValue;
            } else {
              if ( type.mod ) {
                if ( endValue - startValue > type.mod / 2 ) {
                  startValue += type.mod;
                } else if ( startValue - endValue > type.mod / 2 ) {
                  startValue -= type.mod;
                }
              }
              result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
            }
          } );
          return this[ spaceName ]( result );
        },
        blend: function( opaque ) {

          // If we are already opaque - return ourself
          if ( this._rgba[ 3 ] === 1 ) {
            return this;
          }

          var rgb = this._rgba.slice(),
              a = rgb.pop(),
              blend = color( opaque )._rgba;

          return color( jQuery.map( rgb, function( v, i ) {
            return ( 1 - a ) * blend[ i ] + a * v;
          } ) );
        },
        toRgbaString: function() {
          var prefix = "rgba(",
              rgba = jQuery.map( this._rgba, function( v, i ) {
                return v == null ? ( i > 2 ? 1 : 0 ) : v;
              } );

          if ( rgba[ 3 ] === 1 ) {
            rgba.pop();
            prefix = "rgb(";
          }

          return prefix + rgba.join() + ")";
        },
        toHslaString: function() {
          var prefix = "hsla(",
              hsla = jQuery.map( this.hsla(), function( v, i ) {
                if ( v == null ) {
                  v = i > 2 ? 1 : 0;
                }

                // Catch 1 and 2
                if ( i && i < 3 ) {
                  v = Math.round( v * 100 ) + "%";
                }
                return v;
              } );

          if ( hsla[ 3 ] === 1 ) {
            hsla.pop();
            prefix = "hsl(";
          }
          return prefix + hsla.join() + ")";
        },
        toHexString: function( includeAlpha ) {
          var rgba = this._rgba.slice(),
              alpha = rgba.pop();

          if ( includeAlpha ) {
            rgba.push( ~~( alpha * 255 ) );
          }

          return "#" + jQuery.map( rgba, function( v ) {

            // Default to 0 when nulls exist
            v = ( v || 0 ).toString( 16 );
            return v.length === 1 ? "0" + v : v;
          } ).join( "" );
        },
        toString: function() {
          return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
        }
      } );
      color.fn.parse.prototype = color.fn;

// Hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

      function hue2rgb( p, q, h ) {
        h = ( h + 1 ) % 1;
        if ( h * 6 < 1 ) {
          return p + ( q - p ) * h * 6;
        }
        if ( h * 2 < 1 ) {
          return q;
        }
        if ( h * 3 < 2 ) {
          return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
        }
        return p;
      }

      spaces.hsla.to = function( rgba ) {
        if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
          return [ null, null, null, rgba[ 3 ] ];
        }
        var r = rgba[ 0 ] / 255,
            g = rgba[ 1 ] / 255,
            b = rgba[ 2 ] / 255,
            a = rgba[ 3 ],
            max = Math.max( r, g, b ),
            min = Math.min( r, g, b ),
            diff = max - min,
            add = max + min,
            l = add * 0.5,
            h, s;

        if ( min === max ) {
          h = 0;
        } else if ( r === max ) {
          h = ( 60 * ( g - b ) / diff ) + 360;
        } else if ( g === max ) {
          h = ( 60 * ( b - r ) / diff ) + 120;
        } else {
          h = ( 60 * ( r - g ) / diff ) + 240;
        }

        // Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
        // otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
        if ( diff === 0 ) {
          s = 0;
        } else if ( l <= 0.5 ) {
          s = diff / add;
        } else {
          s = diff / ( 2 - add );
        }
        return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
      };

      spaces.hsla.from = function( hsla ) {
        if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
          return [ null, null, null, hsla[ 3 ] ];
        }
        var h = hsla[ 0 ] / 360,
            s = hsla[ 1 ],
            l = hsla[ 2 ],
            a = hsla[ 3 ],
            q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
            p = 2 * l - q;

        return [
          Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
          Math.round( hue2rgb( p, q, h ) * 255 ),
          Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
          a
        ];
      };

      each( spaces, function( spaceName, space ) {
        var props = space.props,
            cache = space.cache,
            to = space.to,
            from = space.from;

        // Makes rgba() and hsla()
        color.fn[ spaceName ] = function( value ) {

          // Generate a cache for this space if it doesn't exist
          if ( to && !this[ cache ] ) {
            this[ cache ] = to( this._rgba );
          }
          if ( value === undefined ) {
            return this[ cache ].slice();
          }

          var ret,
              type = jQuery.type( value ),
              arr = ( type === "array" || type === "object" ) ? value : arguments,
              local = this[ cache ].slice();

          each( props, function( key, prop ) {
            var val = arr[ type === "object" ? key : prop.idx ];
            if ( val == null ) {
              val = local[ prop.idx ];
            }
            local[ prop.idx ] = clamp( val, prop );
          } );

          if ( from ) {
            ret = color( from( local ) );
            ret[ cache ] = local;
            return ret;
          } else {
            return color( local );
          }
        };

        // Makes red() green() blue() alpha() hue() saturation() lightness()
        each( props, function( key, prop ) {

          // Alpha is included in more than one space
          if ( color.fn[ key ] ) {
            return;
          }
          color.fn[ key ] = function( value ) {
            var vtype = jQuery.type( value ),
                fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
                local = this[ fn ](),
                cur = local[ prop.idx ],
                match;

            if ( vtype === "undefined" ) {
              return cur;
            }

            if ( vtype === "function" ) {
              value = value.call( this, cur );
              vtype = jQuery.type( value );
            }
            if ( value == null && prop.empty ) {
              return this;
            }
            if ( vtype === "string" ) {
              match = rplusequals.exec( value );
              if ( match ) {
                value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
              }
            }
            local[ prop.idx ] = value;
            return this[ fn ]( local );
          };
        } );
      } );

// Add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
      color.hook = function( hook ) {
        var hooks = hook.split( " " );
        each( hooks, function( i, hook ) {
          jQuery.cssHooks[ hook ] = {
            set: function( elem, value ) {
              var parsed, curElem,
                  backgroundColor = "";

              if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
                  ( parsed = stringParse( value ) ) ) ) {
                value = color( parsed || value );
                if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
                  curElem = hook === "backgroundColor" ? elem.parentNode : elem;
                  while (
                      ( backgroundColor === "" || backgroundColor === "transparent" ) &&
                      curElem && curElem.style
                      ) {
                    try {
                      backgroundColor = jQuery.css( curElem, "backgroundColor" );
                      curElem = curElem.parentNode;
                    } catch ( e ) {
                    }
                  }

                  value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
                      backgroundColor :
                      "_default" );
                }

                value = value.toRgbaString();
              }
              try {
                elem.style[ hook ] = value;
              } catch ( e ) {

                // Wrapped to prevent IE from throwing errors on "invalid" values like
                // 'auto' or 'inherit'
              }
            }
          };
          jQuery.fx.step[ hook ] = function( fx ) {
            if ( !fx.colorInit ) {
              fx.start = color( fx.elem, hook );
              fx.end = color( fx.end );
              fx.colorInit = true;
            }
            jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
          };
        } );

      };

      color.hook( stepHooks );

      jQuery.cssHooks.borderColor = {
        expand: function( value ) {
          var expanded = {};

          each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
            expanded[ "border" + part + "Color" ] = value;
          } );
          return expanded;
        }
      };

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
      colors = jQuery.Color.names = {

        // 4.1. Basic color keywords
        aqua: "#00ffff",
        black: "#000000",
        blue: "#0000ff",
        fuchsia: "#ff00ff",
        gray: "#808080",
        green: "#008000",
        lime: "#00ff00",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        purple: "#800080",
        red: "#ff0000",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#ffffff",
        yellow: "#ffff00",

        // 4.2.3. "transparent" color keyword
        transparent: [ null, null, null, 0 ],

        _default: "#ffffff"
      };

    } )( jQuery );

    /******************************************************************************/
    /****************************** CLASS ANIMATIONS ******************************/
    /******************************************************************************/
    ( function() {

      var classAnimationActions = [ "add", "remove", "toggle" ],
          shorthandStyles = {
            border: 1,
            borderBottom: 1,
            borderColor: 1,
            borderLeft: 1,
            borderRight: 1,
            borderTop: 1,
            borderWidth: 1,
            margin: 1,
            padding: 1
          };

      $.each(
          [ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
          function( _, prop ) {
            $.fx.step[ prop ] = function( fx ) {
              if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
                jQuery.style( fx.elem, prop, fx.end );
                fx.setAttr = true;
              }
            };
          }
      );

      function getElementStyles( elem ) {
        var key, len,
            style = elem.ownerDocument.defaultView ?
                elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
                elem.currentStyle,
            styles = {};

        if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
          len = style.length;
          while ( len-- ) {
            key = style[ len ];
            if ( typeof style[ key ] === "string" ) {
              styles[ $.camelCase( key ) ] = style[ key ];
            }
          }

          // Support: Opera, IE <9
        } else {
          for ( key in style ) {
            if ( typeof style[ key ] === "string" ) {
              styles[ key ] = style[ key ];
            }
          }
        }

        return styles;
      }

      function styleDifference( oldStyle, newStyle ) {
        var diff = {},
            name, value;

        for ( name in newStyle ) {
          value = newStyle[ name ];
          if ( oldStyle[ name ] !== value ) {
            if ( !shorthandStyles[ name ] ) {
              if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
                diff[ name ] = value;
              }
            }
          }
        }

        return diff;
      }

// Support: jQuery <1.8
      if ( !$.fn.addBack ) {
        $.fn.addBack = function( selector ) {
          return this.add( selector == null ?
              this.prevObject : this.prevObject.filter( selector )
          );
        };
      }

      $.effects.animateClass = function( value, duration, easing, callback ) {
        var o = $.speed( duration, easing, callback );

        return this.queue( function() {
          var animated = $( this ),
              baseClass = animated.attr( "class" ) || "",
              applyClassChange,
              allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

          // Map the animated objects to store the original styles.
          allAnimations = allAnimations.map( function() {
            var el = $( this );
            return {
              el: el,
              start: getElementStyles( this )
            };
          } );

          // Apply class change
          applyClassChange = function() {
            $.each( classAnimationActions, function( i, action ) {
              if ( value[ action ] ) {
                animated[ action + "Class" ]( value[ action ] );
              }
            } );
          };
          applyClassChange();

          // Map all animated objects again - calculate new styles and diff
          allAnimations = allAnimations.map( function() {
            this.end = getElementStyles( this.el[ 0 ] );
            this.diff = styleDifference( this.start, this.end );
            return this;
          } );

          // Apply original class
          animated.attr( "class", baseClass );

          // Map all animated objects again - this time collecting a promise
          allAnimations = allAnimations.map( function() {
            var styleInfo = this,
                dfd = $.Deferred(),
                opts = $.extend( {}, o, {
                  queue: false,
                  complete: function() {
                    dfd.resolve( styleInfo );
                  }
                } );

            this.el.animate( this.diff, opts );
            return dfd.promise();
          } );

          // Once all animations have completed:
          $.when.apply( $, allAnimations.get() ).done( function() {

            // Set the final class
            applyClassChange();

            // For each animated element,
            // clear all css properties that were animated
            $.each( arguments, function() {
              var el = this.el;
              $.each( this.diff, function( key ) {
                el.css( key, "" );
              } );
            } );

            // This is guarnteed to be there if you use jQuery.speed()
            // it also handles dequeuing the next anim...
            o.complete.call( animated[ 0 ] );
          } );
        } );
      };

      $.fn.extend( {
        addClass: ( function( orig ) {
          return function( classNames, speed, easing, callback ) {
            return speed ?
                $.effects.animateClass.call( this,
                    { add: classNames }, speed, easing, callback ) :
                orig.apply( this, arguments );
          };
        } )( $.fn.addClass ),

        removeClass: ( function( orig ) {
          return function( classNames, speed, easing, callback ) {
            return arguments.length > 1 ?
                $.effects.animateClass.call( this,
                    { remove: classNames }, speed, easing, callback ) :
                orig.apply( this, arguments );
          };
        } )( $.fn.removeClass ),

        toggleClass: ( function( orig ) {
          return function( classNames, force, speed, easing, callback ) {
            if ( typeof force === "boolean" || force === undefined ) {
              if ( !speed ) {

                // Without speed parameter
                return orig.apply( this, arguments );
              } else {
                return $.effects.animateClass.call( this,
                    ( force ? { add: classNames } : { remove: classNames } ),
                    speed, easing, callback );
              }
            } else {

              // Without force parameter
              return $.effects.animateClass.call( this,
                  { toggle: classNames }, force, speed, easing );
            }
          };
        } )( $.fn.toggleClass ),

        switchClass: function( remove, add, speed, easing, callback ) {
          return $.effects.animateClass.call( this, {
            add: add,
            remove: remove
          }, speed, easing, callback );
        }
      } );

    } )();

    /******************************************************************************/
    /*********************************** EFFECTS **********************************/
    /******************************************************************************/

    ( function() {

      if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
        $.expr.filters.animated = ( function( orig ) {
          return function( elem ) {
            return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
          };
        } )( $.expr.filters.animated );
      }

      if ( $.uiBackCompat !== false ) {
        $.extend( $.effects, {

          // Saves a set of properties in a data storage
          save: function( element, set ) {
            var i = 0, length = set.length;
            for ( ; i < length; i++ ) {
              if ( set[ i ] !== null ) {
                element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
              }
            }
          },

          // Restores a set of previously saved properties from a data storage
          restore: function( element, set ) {
            var val, i = 0, length = set.length;
            for ( ; i < length; i++ ) {
              if ( set[ i ] !== null ) {
                val = element.data( dataSpace + set[ i ] );
                element.css( set[ i ], val );
              }
            }
          },

          setMode: function( el, mode ) {
            if ( mode === "toggle" ) {
              mode = el.is( ":hidden" ) ? "show" : "hide";
            }
            return mode;
          },

          // Wraps the element around a wrapper that copies position properties
          createWrapper: function( element ) {

            // If the element is already wrapped, return it
            if ( element.parent().is( ".ui-effects-wrapper" ) ) {
              return element.parent();
            }

            // Wrap the element
            var props = {
                  width: element.outerWidth( true ),
                  height: element.outerHeight( true ),
                  "float": element.css( "float" )
                },
                wrapper = $( "<div></div>" )
                    .addClass( "ui-effects-wrapper" )
                    .css( {
                      fontSize: "100%",
                      background: "transparent",
                      border: "none",
                      margin: 0,
                      padding: 0
                    } ),

                // Store the size in case width/height are defined in % - Fixes #5245
                size = {
                  width: element.width(),
                  height: element.height()
                },
                active = document.activeElement;

            // Support: Firefox
            // Firefox incorrectly exposes anonymous content
            // https://bugzilla.mozilla.org/show_bug.cgi?id=561664
            try {
              active.id;
            } catch ( e ) {
              active = document.body;
            }

            element.wrap( wrapper );

            // Fixes #7595 - Elements lose focus when wrapped.
            if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
              $( active ).trigger( "focus" );
            }

            // Hotfix for jQuery 1.4 since some change in wrap() seems to actually
            // lose the reference to the wrapped element
            wrapper = element.parent();

            // Transfer positioning properties to the wrapper
            if ( element.css( "position" ) === "static" ) {
              wrapper.css( { position: "relative" } );
              element.css( { position: "relative" } );
            } else {
              $.extend( props, {
                position: element.css( "position" ),
                zIndex: element.css( "z-index" )
              } );
              $.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
                props[ pos ] = element.css( pos );
                if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
                  props[ pos ] = "auto";
                }
              } );
              element.css( {
                position: "relative",
                top: 0,
                left: 0,
                right: "auto",
                bottom: "auto"
              } );
            }
            element.css( size );

            return wrapper.css( props ).show();
          },

          removeWrapper: function( element ) {
            var active = document.activeElement;

            if ( element.parent().is( ".ui-effects-wrapper" ) ) {
              element.parent().replaceWith( element );

              // Fixes #7595 - Elements lose focus when wrapped.
              if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
                $( active ).trigger( "focus" );
              }
            }

            return element;
          }
        } );
      }

      $.extend( $.effects, {
        version: "1.12.1",

        define: function( name, mode, effect ) {
          if ( !effect ) {
            effect = mode;
            mode = "effect";
          }

          $.effects.effect[ name ] = effect;
          $.effects.effect[ name ].mode = mode;

          return effect;
        },

        scaledDimensions: function( element, percent, direction ) {
          if ( percent === 0 ) {
            return {
              height: 0,
              width: 0,
              outerHeight: 0,
              outerWidth: 0
            };
          }

          var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
              y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

          return {
            height: element.height() * y,
            width: element.width() * x,
            outerHeight: element.outerHeight() * y,
            outerWidth: element.outerWidth() * x
          };

        },

        clipToBox: function( animation ) {
          return {
            width: animation.clip.right - animation.clip.left,
            height: animation.clip.bottom - animation.clip.top,
            left: animation.clip.left,
            top: animation.clip.top
          };
        },

        // Injects recently queued functions to be first in line (after "inprogress")
        unshift: function( element, queueLength, count ) {
          var queue = element.queue();

          if ( queueLength > 1 ) {
            queue.splice.apply( queue,
                [ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
          }
          element.dequeue();
        },

        saveStyle: function( element ) {
          element.data( dataSpaceStyle, element[ 0 ].style.cssText );
        },

        restoreStyle: function( element ) {
          element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
          element.removeData( dataSpaceStyle );
        },

        mode: function( element, mode ) {
          var hidden = element.is( ":hidden" );

          if ( mode === "toggle" ) {
            mode = hidden ? "show" : "hide";
          }
          if ( hidden ? mode === "hide" : mode === "show" ) {
            mode = "none";
          }
          return mode;
        },

        // Translates a [top,left] array into a baseline value
        getBaseline: function( origin, original ) {
          var y, x;

          switch ( origin[ 0 ] ) {
            case "top":
              y = 0;
              break;
            case "middle":
              y = 0.5;
              break;
            case "bottom":
              y = 1;
              break;
            default:
              y = origin[ 0 ] / original.height;
          }

          switch ( origin[ 1 ] ) {
            case "left":
              x = 0;
              break;
            case "center":
              x = 0.5;
              break;
            case "right":
              x = 1;
              break;
            default:
              x = origin[ 1 ] / original.width;
          }

          return {
            x: x,
            y: y
          };
        },

        // Creates a placeholder element so that the original element can be made absolute
        createPlaceholder: function( element ) {
          var placeholder,
              cssPosition = element.css( "position" ),
              position = element.position();

          // Lock in margins first to account for form elements, which
          // will change margin if you explicitly set height
          // see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
          // Support: Safari
          element.css( {
            marginTop: element.css( "marginTop" ),
            marginBottom: element.css( "marginBottom" ),
            marginLeft: element.css( "marginLeft" ),
            marginRight: element.css( "marginRight" )
          } )
              .outerWidth( element.outerWidth() )
              .outerHeight( element.outerHeight() );

          if ( /^(static|relative)/.test( cssPosition ) ) {
            cssPosition = "absolute";

            placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

              // Convert inline to inline block to account for inline elements
              // that turn to inline block based on content (like img)
              display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
                  "inline-block" :
                  "block",
              visibility: "hidden",

              // Margins need to be set to account for margin collapse
              marginTop: element.css( "marginTop" ),
              marginBottom: element.css( "marginBottom" ),
              marginLeft: element.css( "marginLeft" ),
              marginRight: element.css( "marginRight" ),
              "float": element.css( "float" )
            } )
                .outerWidth( element.outerWidth() )
                .outerHeight( element.outerHeight() )
                .addClass( "ui-effects-placeholder" );

            element.data( dataSpace + "placeholder", placeholder );
          }

          element.css( {
            position: cssPosition,
            left: position.left,
            top: position.top
          } );

          return placeholder;
        },

        removePlaceholder: function( element ) {
          var dataKey = dataSpace + "placeholder",
              placeholder = element.data( dataKey );

          if ( placeholder ) {
            placeholder.remove();
            element.removeData( dataKey );
          }
        },

        // Removes a placeholder if it exists and restores
        // properties that were modified during placeholder creation
        cleanUp: function( element ) {
          $.effects.restoreStyle( element );
          $.effects.removePlaceholder( element );
        },

        setTransition: function( element, list, factor, value ) {
          value = value || {};
          $.each( list, function( i, x ) {
            var unit = element.cssUnit( x );
            if ( unit[ 0 ] > 0 ) {
              value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
            }
          } );
          return value;
        }
      } );

// Return an effect options object for the given parameters:
      function _normalizeArguments( effect, options, speed, callback ) {

        // Allow passing all options as the first parameter
        if ( $.isPlainObject( effect ) ) {
          options = effect;
          effect = effect.effect;
        }

        // Convert to an object
        effect = { effect: effect };

        // Catch (effect, null, ...)
        if ( options == null ) {
          options = {};
        }

        // Catch (effect, callback)
        if ( $.isFunction( options ) ) {
          callback = options;
          speed = null;
          options = {};
        }

        // Catch (effect, speed, ?)
        if ( typeof options === "number" || $.fx.speeds[ options ] ) {
          callback = speed;
          speed = options;
          options = {};
        }

        // Catch (effect, options, callback)
        if ( $.isFunction( speed ) ) {
          callback = speed;
          speed = null;
        }

        // Add options to effect
        if ( options ) {
          $.extend( effect, options );
        }

        speed = speed || options.duration;
        effect.duration = $.fx.off ? 0 :
            typeof speed === "number" ? speed :
                speed in $.fx.speeds ? $.fx.speeds[ speed ] :
                    $.fx.speeds._default;

        effect.complete = callback || options.complete;

        return effect;
      }

      function standardAnimationOption( option ) {

        // Valid standard speeds (nothing, number, named speed)
        if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
          return true;
        }

        // Invalid strings - treat as "normal" speed
        if ( typeof option === "string" && !$.effects.effect[ option ] ) {
          return true;
        }

        // Complete callback
        if ( $.isFunction( option ) ) {
          return true;
        }

        // Options hash (but not naming an effect)
        if ( typeof option === "object" && !option.effect ) {
          return true;
        }

        // Didn't match any standard API
        return false;
      }

      $.fn.extend( {
        effect: function( /* effect, options, speed, callback */ ) {
          var args = _normalizeArguments.apply( this, arguments ),
              effectMethod = $.effects.effect[ args.effect ],
              defaultMode = effectMethod.mode,
              queue = args.queue,
              queueName = queue || "fx",
              complete = args.complete,
              mode = args.mode,
              modes = [],
              prefilter = function( next ) {
                var el = $( this ),
                    normalizedMode = $.effects.mode( el, mode ) || defaultMode;

                // Sentinel for duck-punching the :animated psuedo-selector
                el.data( dataSpaceAnimated, true );

                // Save effect mode for later use,
                // we can't just call $.effects.mode again later,
                // as the .show() below destroys the initial state
                modes.push( normalizedMode );

                // See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
                if ( defaultMode && ( normalizedMode === "show" ||
                    ( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
                  el.show();
                }

                if ( !defaultMode || normalizedMode !== "none" ) {
                  $.effects.saveStyle( el );
                }

                if ( $.isFunction( next ) ) {
                  next();
                }
              };

          if ( $.fx.off || !effectMethod ) {

            // Delegate to the original method (e.g., .show()) if possible
            if ( mode ) {
              return this[ mode ]( args.duration, complete );
            } else {
              return this.each( function() {
                if ( complete ) {
                  complete.call( this );
                }
              } );
            }
          }

          function run( next ) {
            var elem = $( this );

            function cleanup() {
              elem.removeData( dataSpaceAnimated );

              $.effects.cleanUp( elem );

              if ( args.mode === "hide" ) {
                elem.hide();
              }

              done();
            }

            function done() {
              if ( $.isFunction( complete ) ) {
                complete.call( elem[ 0 ] );
              }

              if ( $.isFunction( next ) ) {
                next();
              }
            }

            // Override mode option on a per element basis,
            // as toggle can be either show or hide depending on element state
            args.mode = modes.shift();

            if ( $.uiBackCompat !== false && !defaultMode ) {
              if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

                // Call the core method to track "olddisplay" properly
                elem[ mode ]();
                done();
              } else {
                effectMethod.call( elem[ 0 ], args, done );
              }
            } else {
              if ( args.mode === "none" ) {

                // Call the core method to track "olddisplay" properly
                elem[ mode ]();
                done();
              } else {
                effectMethod.call( elem[ 0 ], args, cleanup );
              }
            }
          }

          // Run prefilter on all elements first to ensure that
          // any showing or hiding happens before placeholder creation,
          // which ensures that any layout changes are correctly captured.
          return queue === false ?
              this.each( prefilter ).each( run ) :
              this.queue( queueName, prefilter ).queue( queueName, run );
        },

        show: ( function( orig ) {
          return function( option ) {
            if ( standardAnimationOption( option ) ) {
              return orig.apply( this, arguments );
            } else {
              var args = _normalizeArguments.apply( this, arguments );
              args.mode = "show";
              return this.effect.call( this, args );
            }
          };
        } )( $.fn.show ),

        hide: ( function( orig ) {
          return function( option ) {
            if ( standardAnimationOption( option ) ) {
              return orig.apply( this, arguments );
            } else {
              var args = _normalizeArguments.apply( this, arguments );
              args.mode = "hide";
              return this.effect.call( this, args );
            }
          };
        } )( $.fn.hide ),

        toggle: ( function( orig ) {
          return function( option ) {
            if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
              return orig.apply( this, arguments );
            } else {
              var args = _normalizeArguments.apply( this, arguments );
              args.mode = "toggle";
              return this.effect.call( this, args );
            }
          };
        } )( $.fn.toggle ),

        cssUnit: function( key ) {
          var style = this.css( key ),
              val = [];

          $.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
            if ( style.indexOf( unit ) > 0 ) {
              val = [ parseFloat( style ), unit ];
            }
          } );
          return val;
        },

        cssClip: function( clipObj ) {
          if ( clipObj ) {
            return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
                clipObj.bottom + "px " + clipObj.left + "px)" );
          }
          return parseClip( this.css( "clip" ), this );
        },

        transfer: function( options, done ) {
          var element = $( this ),
              target = $( options.to ),
              targetFixed = target.css( "position" ) === "fixed",
              body = $( "body" ),
              fixTop = targetFixed ? body.scrollTop() : 0,
              fixLeft = targetFixed ? body.scrollLeft() : 0,
              endPosition = target.offset(),
              animation = {
                top: endPosition.top - fixTop,
                left: endPosition.left - fixLeft,
                height: target.innerHeight(),
                width: target.innerWidth()
              },
              startPosition = element.offset(),
              transfer = $( "<div class='ui-effects-transfer'></div>" )
                  .appendTo( "body" )
                  .addClass( options.className )
                  .css( {
                    top: startPosition.top - fixTop,
                    left: startPosition.left - fixLeft,
                    height: element.innerHeight(),
                    width: element.innerWidth(),
                    position: targetFixed ? "fixed" : "absolute"
                  } )
                  .animate( animation, options.duration, options.easing, function() {
                    transfer.remove();
                    if ( $.isFunction( done ) ) {
                      done();
                    }
                  } );
        }
      } );

      function parseClip( str, element ) {
        var outerWidth = element.outerWidth(),
            outerHeight = element.outerHeight(),
            clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
            values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

        return {
          top: parseFloat( values[ 1 ] ) || 0,
          right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
          bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
          left: parseFloat( values[ 4 ] ) || 0
        };
      }

      $.fx.step.clip = function( fx ) {
        if ( !fx.clipInit ) {
          fx.start = $( fx.elem ).cssClip();
          if ( typeof fx.end === "string" ) {
            fx.end = parseClip( fx.end, fx.elem );
          }
          fx.clipInit = true;
        }

        $( fx.elem ).cssClip( {
          top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
          right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
          bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
          left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
        } );
      };

    } )();

    /******************************************************************************/
    /*********************************** EASING ***********************************/
    /******************************************************************************/

    ( function() {

// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

      var baseEasings = {};

      $.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
        baseEasings[ name ] = function( p ) {
          return Math.pow( p, i + 2 );
        };
      } );

      $.extend( baseEasings, {
        Sine: function( p ) {
          return 1 - Math.cos( p * Math.PI / 2 );
        },
        Circ: function( p ) {
          return 1 - Math.sqrt( 1 - p * p );
        },
        Elastic: function( p ) {
          return p === 0 || p === 1 ? p :
              -Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
        },
        Back: function( p ) {
          return p * p * ( 3 * p - 2 );
        },
        Bounce: function( p ) {
          var pow2,
              bounce = 4;

          while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
          return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
        }
      } );

      $.each( baseEasings, function( name, easeIn ) {
        $.easing[ "easeIn" + name ] = easeIn;
        $.easing[ "easeOut" + name ] = function( p ) {
          return 1 - easeIn( 1 - p );
        };
        $.easing[ "easeInOut" + name ] = function( p ) {
          return p < 0.5 ?
              easeIn( p * 2 ) / 2 :
              1 - easeIn( p * -2 + 2 ) / 2;
        };
      } );

    } )();

    var effect = $.effects;


    /*!
 * jQuery UI Effects Blind 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: http://api.jqueryui.com/blind-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
      var map = {
            up: [ "bottom", "top" ],
            vertical: [ "bottom", "top" ],
            down: [ "top", "bottom" ],
            left: [ "right", "left" ],
            horizontal: [ "right", "left" ],
            right: [ "left", "right" ]
          },
          element = $( this ),
          direction = options.direction || "up",
          start = element.cssClip(),
          animate = { clip: $.extend( {}, start ) },
          placeholder = $.effects.createPlaceholder( element );

      animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

      if ( options.mode === "show" ) {
        element.cssClip( animate.clip );
        if ( placeholder ) {
          placeholder.css( $.effects.clipToBox( animate ) );
        }

        animate.clip = start;
      }

      if ( placeholder ) {
        placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
      }

      element.animate( animate, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: done
      } );
    } );


    /*!
 * jQuery UI Effects Bounce 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/bounce-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
      var upAnim, downAnim, refValue,
          element = $( this ),

          // Defaults:
          mode = options.mode,
          hide = mode === "hide",
          show = mode === "show",
          direction = options.direction || "up",
          distance = options.distance,
          times = options.times || 5,

          // Number of internal animations
          anims = times * 2 + ( show || hide ? 1 : 0 ),
          speed = options.duration / anims,
          easing = options.easing,

          // Utility:
          ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
          motion = ( direction === "up" || direction === "left" ),
          i = 0,

          queuelen = element.queue().length;

      $.effects.createPlaceholder( element );

      refValue = element.css( ref );

      // Default distance for the BIGGEST bounce is the outer Distance / 3
      if ( !distance ) {
        distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
      }

      if ( show ) {
        downAnim = { opacity: 1 };
        downAnim[ ref ] = refValue;

        // If we are showing, force opacity 0 and set the initial position
        // then do the "first" animation
        element
            .css( "opacity", 0 )
            .css( ref, motion ? -distance * 2 : distance * 2 )
            .animate( downAnim, speed, easing );
      }

      // Start at the smallest distance if we are hiding
      if ( hide ) {
        distance = distance / Math.pow( 2, times - 1 );
      }

      downAnim = {};
      downAnim[ ref ] = refValue;

      // Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
      for ( ; i < times; i++ ) {
        upAnim = {};
        upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

        element
            .animate( upAnim, speed, easing )
            .animate( downAnim, speed, easing );

        distance = hide ? distance * 2 : distance / 2;
      }

      // Last Bounce when Hiding
      if ( hide ) {
        upAnim = { opacity: 0 };
        upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

        element.animate( upAnim, speed, easing );
      }

      element.queue( done );

      $.effects.unshift( element, queuelen, anims + 1 );
    } );


    /*!
 * jQuery UI Effects Clip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: http://api.jqueryui.com/clip-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
      var start,
          animate = {},
          element = $( this ),
          direction = options.direction || "vertical",
          both = direction === "both",
          horizontal = both || direction === "horizontal",
          vertical = both || direction === "vertical";

      start = element.cssClip();
      animate.clip = {
        top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
        right: horizontal ? ( start.right - start.left ) / 2 : start.right,
        bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
        left: horizontal ? ( start.right - start.left ) / 2 : start.left
      };

      $.effects.createPlaceholder( element );

      if ( options.mode === "show" ) {
        element.cssClip( animate.clip );
        animate.clip = start;
      }

      element.animate( animate, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: done
      } );

    } );


    /*!
 * jQuery UI Effects Drop 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: http://api.jqueryui.com/drop-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

      var distance,
          element = $( this ),
          mode = options.mode,
          show = mode === "show",
          direction = options.direction || "left",
          ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
          motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
          oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
          animation = {
            opacity: 0
          };

      $.effects.createPlaceholder( element );

      distance = options.distance ||
          element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

      animation[ ref ] = motion + distance;

      if ( show ) {
        element.css( animation );

        animation[ ref ] = oppositeMotion + distance;
        animation.opacity = 1;
      }

      // Animate
      element.animate( animation, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: done
      } );
    } );


    /*!
 * jQuery UI Effects Explode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/explode-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

      var i, j, left, top, mx, my,
          rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
          cells = rows,
          element = $( this ),
          mode = options.mode,
          show = mode === "show",

          // Show and then visibility:hidden the element before calculating offset
          offset = element.show().css( "visibility", "hidden" ).offset(),

          // Width and height of a piece
          width = Math.ceil( element.outerWidth() / cells ),
          height = Math.ceil( element.outerHeight() / rows ),
          pieces = [];

      // Children animate complete:
      function childComplete() {
        pieces.push( this );
        if ( pieces.length === rows * cells ) {
          animComplete();
        }
      }

      // Clone the element for each row and cell.
      for ( i = 0; i < rows; i++ ) { // ===>
        top = offset.top + i * height;
        my = i - ( rows - 1 ) / 2;

        for ( j = 0; j < cells; j++ ) { // |||
          left = offset.left + j * width;
          mx = j - ( cells - 1 ) / 2;

          // Create a clone of the now hidden main element that will be absolute positioned
          // within a wrapper div off the -left and -top equal to size of our pieces
          element
              .clone()
              .appendTo( "body" )
              .wrap( "<div></div>" )
              .css( {
                position: "absolute",
                visibility: "visible",
                left: -j * width,
                top: -i * height
              } )

              // Select the wrapper - make it overflow: hidden and absolute positioned based on
              // where the original was located +left and +top equal to the size of pieces
              .parent()
              .addClass( "ui-effects-explode" )
              .css( {
                position: "absolute",
                overflow: "hidden",
                width: width,
                height: height,
                left: left + ( show ? mx * width : 0 ),
                top: top + ( show ? my * height : 0 ),
                opacity: show ? 0 : 1
              } )
              .animate( {
                left: left + ( show ? 0 : mx * width ),
                top: top + ( show ? 0 : my * height ),
                opacity: show ? 1 : 0
              }, options.duration || 500, options.easing, childComplete );
        }
      }

      function animComplete() {
        element.css( {
          visibility: "visible"
        } );
        $( pieces ).remove();
        done();
      }
    } );


    /*!
 * jQuery UI Effects Fade 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: http://api.jqueryui.com/fade-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
      var show = options.mode === "show";

      $( this )
          .css( "opacity", show ? 0 : 1 )
          .animate( {
            opacity: show ? 1 : 0
          }, {
            queue: false,
            duration: options.duration,
            easing: options.easing,
            complete: done
          } );
    } );


    /*!
 * jQuery UI Effects Fold 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: http://api.jqueryui.com/fold-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

      // Create element
      var element = $( this ),
          mode = options.mode,
          show = mode === "show",
          hide = mode === "hide",
          size = options.size || 15,
          percent = /([0-9]+)%/.exec( size ),
          horizFirst = !!options.horizFirst,
          ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
          duration = options.duration / 2,

          placeholder = $.effects.createPlaceholder( element ),

          start = element.cssClip(),
          animation1 = { clip: $.extend( {}, start ) },
          animation2 = { clip: $.extend( {}, start ) },

          distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

          queuelen = element.queue().length;

      if ( percent ) {
        size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
      }
      animation1.clip[ ref[ 0 ] ] = size;
      animation2.clip[ ref[ 0 ] ] = size;
      animation2.clip[ ref[ 1 ] ] = 0;

      if ( show ) {
        element.cssClip( animation2.clip );
        if ( placeholder ) {
          placeholder.css( $.effects.clipToBox( animation2 ) );
        }

        animation2.clip = start;
      }

      // Animate
      element
          .queue( function( next ) {
            if ( placeholder ) {
              placeholder
                  .animate( $.effects.clipToBox( animation1 ), duration, options.easing )
                  .animate( $.effects.clipToBox( animation2 ), duration, options.easing );
            }

            next();
          } )
          .animate( animation1, duration, options.easing )
          .animate( animation2, duration, options.easing )
          .queue( done );

      $.effects.unshift( element, queuelen, 4 );
    } );


    /*!
 * jQuery UI Effects Highlight 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: http://api.jqueryui.com/highlight-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
      var element = $( this ),
          animation = {
            backgroundColor: element.css( "backgroundColor" )
          };

      if ( options.mode === "hide" ) {
        animation.opacity = 0;
      }

      $.effects.saveStyle( element );

      element
          .css( {
            backgroundImage: "none",
            backgroundColor: options.color || "#ffff99"
          } )
          .animate( animation, {
            queue: false,
            duration: options.duration,
            easing: options.easing,
            complete: done
          } );
    } );


    /*!
 * jQuery UI Effects Size 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: http://api.jqueryui.com/size-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectSize = $.effects.define( "size", function( options, done ) {

      // Create element
      var baseline, factor, temp,
          element = $( this ),

          // Copy for children
          cProps = [ "fontSize" ],
          vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
          hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

          // Set options
          mode = options.mode,
          restore = mode !== "effect",
          scale = options.scale || "both",
          origin = options.origin || [ "middle", "center" ],
          position = element.css( "position" ),
          pos = element.position(),
          original = $.effects.scaledDimensions( element ),
          from = options.from || original,
          to = options.to || $.effects.scaledDimensions( element, 0 );

      $.effects.createPlaceholder( element );

      if ( mode === "show" ) {
        temp = from;
        from = to;
        to = temp;
      }

      // Set scaling factor
      factor = {
        from: {
          y: from.height / original.height,
          x: from.width / original.width
        },
        to: {
          y: to.height / original.height,
          x: to.width / original.width
        }
      };

      // Scale the css box
      if ( scale === "box" || scale === "both" ) {

        // Vertical props scaling
        if ( factor.from.y !== factor.to.y ) {
          from = $.effects.setTransition( element, vProps, factor.from.y, from );
          to = $.effects.setTransition( element, vProps, factor.to.y, to );
        }

        // Horizontal props scaling
        if ( factor.from.x !== factor.to.x ) {
          from = $.effects.setTransition( element, hProps, factor.from.x, from );
          to = $.effects.setTransition( element, hProps, factor.to.x, to );
        }
      }

      // Scale the content
      if ( scale === "content" || scale === "both" ) {

        // Vertical props scaling
        if ( factor.from.y !== factor.to.y ) {
          from = $.effects.setTransition( element, cProps, factor.from.y, from );
          to = $.effects.setTransition( element, cProps, factor.to.y, to );
        }
      }

      // Adjust the position properties based on the provided origin points
      if ( origin ) {
        baseline = $.effects.getBaseline( origin, original );
        from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
        from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
        to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
        to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
      }
      element.css( from );

      // Animate the children if desired
      if ( scale === "content" || scale === "both" ) {

        vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
        hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

        // Only animate children with width attributes specified
        // TODO: is this right? should we include anything with css width specified as well
        element.find( "*[width]" ).each( function() {
          var child = $( this ),
              childOriginal = $.effects.scaledDimensions( child ),
              childFrom = {
                height: childOriginal.height * factor.from.y,
                width: childOriginal.width * factor.from.x,
                outerHeight: childOriginal.outerHeight * factor.from.y,
                outerWidth: childOriginal.outerWidth * factor.from.x
              },
              childTo = {
                height: childOriginal.height * factor.to.y,
                width: childOriginal.width * factor.to.x,
                outerHeight: childOriginal.height * factor.to.y,
                outerWidth: childOriginal.width * factor.to.x
              };

          // Vertical props scaling
          if ( factor.from.y !== factor.to.y ) {
            childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
            childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
          }

          // Horizontal props scaling
          if ( factor.from.x !== factor.to.x ) {
            childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
            childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
          }

          if ( restore ) {
            $.effects.saveStyle( child );
          }

          // Animate children
          child.css( childFrom );
          child.animate( childTo, options.duration, options.easing, function() {

            // Restore children
            if ( restore ) {
              $.effects.restoreStyle( child );
            }
          } );
        } );
      }

      // Animate
      element.animate( to, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: function() {

          var offset = element.offset();

          if ( to.opacity === 0 ) {
            element.css( "opacity", from.opacity );
          }

          if ( !restore ) {
            element
                .css( "position", position === "static" ? "relative" : position )
                .offset( offset );

            // Need to save style here so that automatic style restoration
            // doesn't restore to the original styles from before the animation.
            $.effects.saveStyle( element );
          }

          done();
        }
      } );

    } );


    /*!
 * jQuery UI Effects Scale 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: http://api.jqueryui.com/scale-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

      // Create element
      var el = $( this ),
          mode = options.mode,
          percent = parseInt( options.percent, 10 ) ||
              ( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

          newOptions = $.extend( true, {
            from: $.effects.scaledDimensions( el ),
            to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
            origin: options.origin || [ "middle", "center" ]
          }, options );

      // Fade option to support puff
      if ( options.fade ) {
        newOptions.from.opacity = 1;
        newOptions.to.opacity = 0;
      }

      $.effects.effect.size.call( this, newOptions, done );
    } );


    /*!
 * jQuery UI Effects Puff 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: http://api.jqueryui.com/puff-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
      var newOptions = $.extend( true, {}, options, {
        fade: true,
        percent: parseInt( options.percent, 10 ) || 150
      } );

      $.effects.effect.scale.call( this, newOptions, done );
    } );


    /*!
 * jQuery UI Effects Pulsate 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: http://api.jqueryui.com/pulsate-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
      var element = $( this ),
          mode = options.mode,
          show = mode === "show",
          hide = mode === "hide",
          showhide = show || hide,

          // Showing or hiding leaves off the "last" animation
          anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
          duration = options.duration / anims,
          animateTo = 0,
          i = 1,
          queuelen = element.queue().length;

      if ( show || !element.is( ":visible" ) ) {
        element.css( "opacity", 0 ).show();
        animateTo = 1;
      }

      // Anims - 1 opacity "toggles"
      for ( ; i < anims; i++ ) {
        element.animate( { opacity: animateTo }, duration, options.easing );
        animateTo = 1 - animateTo;
      }

      element.animate( { opacity: animateTo }, duration, options.easing );

      element.queue( done );

      $.effects.unshift( element, queuelen, anims + 1 );
    } );


    /*!
 * jQuery UI Effects Shake 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/shake-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

      var i = 1,
          element = $( this ),
          direction = options.direction || "left",
          distance = options.distance || 20,
          times = options.times || 3,
          anims = times * 2 + 1,
          speed = Math.round( options.duration / anims ),
          ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
          positiveMotion = ( direction === "up" || direction === "left" ),
          animation = {},
          animation1 = {},
          animation2 = {},

          queuelen = element.queue().length;

      $.effects.createPlaceholder( element );

      // Animation
      animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
      animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
      animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

      // Animate
      element.animate( animation, speed, options.easing );

      // Shakes
      for ( ; i < times; i++ ) {
        element
            .animate( animation1, speed, options.easing )
            .animate( animation2, speed, options.easing );
      }

      element
          .animate( animation1, speed, options.easing )
          .animate( animation, speed / 2, options.easing )
          .queue( done );

      $.effects.unshift( element, queuelen, anims + 1 );
    } );


    /*!
 * jQuery UI Effects Slide 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: http://api.jqueryui.com/slide-effect/
//>>demos: http://jqueryui.com/effect/



    var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
      var startClip, startRef,
          element = $( this ),
          map = {
            up: [ "bottom", "top" ],
            down: [ "top", "bottom" ],
            left: [ "right", "left" ],
            right: [ "left", "right" ]
          },
          mode = options.mode,
          direction = options.direction || "left",
          ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
          positiveMotion = ( direction === "up" || direction === "left" ),
          distance = options.distance ||
              element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
          animation = {};

      $.effects.createPlaceholder( element );

      startClip = element.cssClip();
      startRef = element.position()[ ref ];

      // Define hide animation
      animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
      animation.clip = element.cssClip();
      animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

      // Reverse the animation if we're showing
      if ( mode === "show" ) {
        element.cssClip( animation.clip );
        element.css( ref, animation[ ref ] );
        animation.clip = startClip;
        animation[ ref ] = startRef;
      }

      // Actually animate
      element.animate( animation, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: done
      } );
    } );


    /*!
 * jQuery UI Effects Transfer 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: http://api.jqueryui.com/transfer-effect/
//>>demos: http://jqueryui.com/effect/



    var effect;
    if ( $.uiBackCompat !== false ) {
      effect = $.effects.define( "transfer", function( options, done ) {
        $( this ).transfer( options, done );
      } );
    }
    var effectsEffectTransfer = effect;

  }));

  if ($(window).width() < 769) {
    $(".product-tabs").tabs({
      active: { active: 1 }
    });
  }
  else {
    $(".product-tabs").tabs({
      active: { active: 1 } ,
      show: { effect: "slide", direction: "left", duration: 200, easing: "easeOutBack" } ,
      hide: { effect: "slide", direction: "right", duration: 200, easing: "easeInQuad" }
    });
  }

  /* $('.product-details-item').slice(4).addClass('hide');
  $('.js-toogle-product-details-item').click(function () {
    $('.product-details-item').slice(4).toggleClass('hide');
    $(this).text(function(i, v){
      return v === 'Read More' ? 'Read Less' : 'Read More'
    })
  }); */

  $('.input-quantity-select').click(function(){
    $('.input-quantity-dropdown').show();
  });

  $('.input-quantity-select').blur(function(){
    var currentSelectQuantity = $(this).val();
    if (currentSelectQuantity == '') {
      $(this).val('1');
    }
  });

  $('.input-quantity-dropdown li').click(function () {
    var selectQuantityValue = $(this).val();
    $('.input-quantity-select').val(selectQuantityValue);
    $('.input-quantity-dropdown').hide();
  });

  $(document).click(function (e) {
    var container = $(".datalist-arrow");
    if (container.has(e.target).length === 0){
      $('.input-quantity-dropdown').hide();
    }
  });

  $('.js-open-search-modal, .js-search-header').click(function(){
    $('.searchModal').addClass('searchModalOpen');
    $('body').addClass('searchModalOpenBody');
    $('body').css('overflow', 'hidden');
    setTimeout(function(){
      $('.klevu-search-suggestion.search__input').focus();
      $('.klevu-pt-rs-hover').addClass('klevu-pt-rs-hover-custom');
    }, 500);
  });

  $('.searchModal .klevu-search-suggestion').on('input', function() {
    var inputLetter = $(this).val();
    if (inputLetter.length < 3) {
      $('#klevuMinLtr').addClass('klevuMinLtr-custom');
    }
  });

  $(document).mouseup(function (e){
    var div = $(".searchModalOpen form.search");
    var klaviyoCustomModal = $(".klaviyo-form");
    if (!div.is(e.target) && div.has(e.target).length === 0 && $('.klevu-searching-area').has(e.target).length === 0) {
      $('.searchModal').removeClass('searchModalOpen');
      $('.searchModalOpenBody .klevu-search-suggestion').val('');
      $('.searchModalOpenBody .klevu-searching-area.klevu-searching-with-cms').css('display', 'none', '!important');
      $('.searchModalOpenBody .klevu-pt-rs-hover').removeClass('klevu-pt-rs-hover-custom');
      $('.searchModalOpenBody .klevu-pt-rs-hover').hide();
      $('.searchModalOpenBody .klevu-min-ltr').hide();
      $('#klevuMinLtr').removeClass('klevuMinLtr-custom');
      $('body').css('overflow', 'auto');
      $('body').removeClass('searchModalOpenBody');
    }

    if (!klaviyoCustomModal.is(e.target) && klaviyoCustomModal.has(e.target).length === 0) {
      $('.klaviyo-custom-modal').removeClass('klaviyo-custom-modal--active');
    }

  });

  $(document).ready(function () {
    var inputQuantitySelectMax = $('.input-quantity-select').attr('max');
    $('.input-quantity-select').on('input', function() {
      if (Number(this.value) > Number(inputQuantitySelectMax)) {
        $('.product-add-to-cart-wrapper .product__quantity--button').append('<span class="error-quantity-type">Enter '+inputQuantitySelectMax+' or less</span>');
        $('.input-quantity-dropdown').hide();
        setTimeout(function(){
          $('.error-quantity-type').remove();
        }, 2500);
      }
      this.value = Math.min(inputQuantitySelectMax, Math.max(1, this.value));
    });
  });

  // For collection and search result pages input in filters
  $(document).ready(function () {
    var inputMinPriceFilterMin = $('.minValueInput').attr('min');
    var inputMinPriceFilterMax = $('.minValueInput').attr('max');
    var inputMaxPriceFilterMin = $('.maxValueInput').attr('min');
    var inputMaxPriceFilterMax = $('.maxValueInput').attr('max');
    $('.minValueInput').on('input', function() {
      this.value = Math.min(inputMinPriceFilterMin, Math.min(1, this.value));
      this.value = Math.min(inputMinPriceFilterMax, Math.max(1, this.value));
    });
    $('.maxValueInput').on('input', function() {
      this.value = Math.min(inputMaxPriceFilterMin, Math.min(1, this.value));
      this.value = Math.min(inputMaxPriceFilterMax, Math.max(1, this.value));
    });
  });

  // Checkbox cart page
  $(function(){
    $('.js-age-checkbox-verification').on('change', function(){
      if($('.js-age-checkbox-verification').prop('checked')){
        $('.js-cart-checkout').attr('disabled', false);
      }else{
        $('.js-cart-checkout').attr('disabled', true);
      }
    });
  });


  // Modal pre-order
  $('.js-close-modal').click(function(){
    $('.modal-preorder').hide();
  });

  $('.modal-preorder .btn').click(function(){
    setTimeout(function(){ 
      $('body').trigger('added.ajaxProduct');
    }, 500);
  });

  //Announcement bar mobile placeholder
  const mobileQuery = window.matchMedia('(max-width: 768px)')

  if (mobileQuery.matches) {
      let emailInput = $('.announcement-bar form input[name="contact[email]"]');
      let placeholderText = $('.js-announcement-mobile-placeholder').text();
      console.log(emailInput, placeholderText);
      emailInput.attr('placeholder', placeholderText);
  }

  $('.js-open-klaviyo-custom-modal').click(function(){
    $('.klaviyo-custom-modal').addClass('klaviyo-custom-modal--active');
  });

  $(document).on("click touchend", ".Button__FormStyledButton-p2mbjt-0.cySkQL", function () {
    $('.klaviyo-custom-modal').removeClass('klaviyo-custom-modal--active');
  });

  $('.shipping-policy-page_navigation a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    var sc = $(this).attr("href"),
        dn = $(sc).position().top;

    if (mobileQuery.matches) {
      var dnMobile = 150
    }
    else {
      var dnMobile = 0
    }
    $('html, body').animate({scrollTop: dn + dnMobile}, 1000);
  });

  $(document).ready(function () {
    $(".site-nav--has-dropdown").hover(function() {
      $("#tidio-chat-iframe").hide();
      $('body').addClass('open-mega-menu');
    }, function() {
      $("#tidio-chat-iframe").show();
      $('body').removeClass('open-mega-menu');
    });
  });

  $('.blog-widget-slider').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    responsive: [
        {
          breakpoint: 1132,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.experiences_testimonials-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1132,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 510,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

})(theme.jQuery);

if(location.href.indexOf("/blogs/happenings") > -1) {
  function instagramOnBlogPage() {
    console.log('Instagram Done');
    $('.blog-custom-wrapper').addClass('preload-done');
  }

  var instagramListener = function(event) {
    if (event.animationName === "instagramOnBlogPagePoint") {
      instagramOnBlogPage();
    }
  }

  document.addEventListener("animationstart", instagramListener, false); // standard + firefox
  document.addEventListener("MSAnimationStart", instagramListener, false); // IE
  document.addEventListener("webkitAnimationStart", instagramListener, false); // Chrome + Safari
}

// Script for footer height var
// var sliderHero = document.getElementsByClassName('hero--index')[0];
// var footerHeight = document.getElementsByClassName('site-footer')[0].clientHeight;
// sliderHero.style.setProperty('--footerHeight', footerHeight);

Handlebars.registerHelper('ifEquals', function(arg1, arg2) { // This handlebar was added with the purpose to use it in ajax-cart-template.liquid to check equality for properties of line-items 
  return (arg1 == arg2) ? (this) : !(this);
});

Handlebars.registerHelper('contains', function(needle, haystack, options) {
  needle = Handlebars.escapeExpression(needle);
  haystack = Handlebars.escapeExpression(haystack);
  return (haystack.indexOf(needle) > -1) ? options.fn(this) : options.inverse(this);
});

// Sticky header
// const stickyNav = document.querySelector('.sticky-header');
// let topStickyNav = stickyNav.offsetTop;
// function fixNav() {
//   if (window.scrollY >= topStickyNav) {
//     document.body.style.paddingTop = stickyNav.offsetHeight + 'px';
//     document.body.classList.add('fixed-nav');
//   } else {
//     document.body.classList.remove('fixed-nav');
//     document.body.style.paddingTop = 0;
//   }
// }

// window.addEventListener('scroll', fixNav);


/* Scroll for footer navigation */
if(location.href.indexOf("shipping-policy") > -1){
	if(location.href.indexOf("#return-policy") > -1)
		document.getElementById("shipping-policy-page_return-policy").scrollIntoView({block: "center", behavior: "smooth"});
	if(location.href.indexOf("#cancellation-policy") > -1)
		document.getElementById("shipping-policy-page_cancellation-policy").scrollIntoView({block: "center", behavior: "smooth"});
		
	$('.site-footer__linklist a[href^="/"]').on('click', function(event) {
		const mobileQuery = window.matchMedia('(max-width: 768px)');
		var sc = $(this).attr("href");
		if(sc == "/pages/shipping-policy"){
			event.preventDefault();
			sc = "#shipping-policy-page_shipping-policy";
			dn = $(sc).position().top
			if (mobileQuery.matches) {
			  var dnMobile = 150
			}
			else {
			  var dnMobile = 0
			}
			$('html, body').animate({scrollTop: dn + dnMobile}, 1000);
		}
		if(sc.indexOf("#") > -1){
			var ref = sc.split("#");
			if(ref[1] == "return-policy")
				ref[1] = "#shipping-policy-page_return-policy";
			if(ref[1] == "cancellation-policy")
				ref[1] = "#shipping-policy-page_cancellation-policy";
			var dn = $(ref[1]).position().top;
			if (mobileQuery.matches) {
			  var dnMobile = 150
			}
			else {
			  var dnMobile = 0
			}
			$('html, body').animate({scrollTop: dn + dnMobile}, 1000);
		}
	});
}

$(document).ready(function (){
  setTimeout(function (){
    $('.bold-pre-compare-price').closest('.cart__row').find('.money.pre-money').css('color', '#7d9b55');
  }, 100);

  $('.js-cart-regprice-input').on('change', function (){
    setTimeout(function (){
      if($('.bold-pre-compare-price').length > 0) {
        $('.bold-pre-compare-price').closest('.cart__row').find('.money.pre-money').css('color', '#7d9b55');
      }
      else {
        $('.cart__row').find('.money.pre-money').css('color', '#373d4a');
      }
    }, 100);

    let regpriceItemsNumber = 0;
    $('.js-cart-regprice-input').each((index, input) => {
      regpriceItemsNumber += parseInt(input.value);
    });
    updateRegpriceProgressbar(regpriceItemsNumber);

    $('.h4.total-price .money.pre-money').on('DOMSubtreeModified', function (){
      if(!!$('.h4.total-price .money.pre-money').text()){
        updateShippingCalculatorValues();
      }
    });
    setTimeout(updateShippingCalculatorValues, 2000);
  });
  $('input[type=radio][name="cbb-shipping-rate-name-*"]').change(function() {
    console.log('CHANGE');
  });

  setTimeout(updateShippingCalculatorValues, 500);

  let isShippingCalculatorLoaded = setInterval(checkIfShippingRatesVisible, 100);
  function checkIfShippingRatesVisible(){
    let isDesktopView = $('.cbb-desktop-view').length > 0;
    let isMobileView = $('.cbb-mobile-view').length > 0;
    if(isMobileView) {
      if($('.cbb-mobile-view #cbb-shipping-rates-calculator-cart-subtotal').is(':visible')){
        setTimeout(updateShippingCalculatorValues, 500);
        clearInterval(isShippingCalculatorLoaded);
      }
    }
    if(isDesktopView){
      if($('.cbb-desktop-view #cbb-shipping-rates-calculator-cart-subtotal').is(':visible')){
        setTimeout(updateShippingCalculatorValues, 500);
        clearInterval(isShippingCalculatorLoaded);
      }
    }
  }
});

function updateShippingCalculatorValues(){
    let subtotalValue = $('.h4.total-price .money.pre-money').text();
    let subtotalPrice = parseFloat(subtotalValue.substr(1).replace(/,/g, ''));
    let shippingPrice = parseFloat($('.cbb-shipping-rates-calculator-shipping-subtotal .money').text().substr(1).replace(/,/g, ''));
    let totalValue = `$${(subtotalPrice + shippingPrice).toFixed(2).toLocaleString()}`;
    $('.cbb-shipping-rates-calculator-cart-subtotal .money').text(subtotalValue);
    $('.cbb-shipping-rates-calculator-cart-total .money').text(totalValue);
}

function updateRegpriceProgressbar(regpriceItemsNumber){
  if (meta.page.pageType == 'product') {
    var checkProductType = meta.product.type;
  } else {
    var checkProductType = meta;
  }
  console.log('checkProductType', checkProductType);
  if(regpriceItemsNumber > 0) {
    $('.js-cart-header').addClass('regprice');
    $('.js-cart-regprice').removeClass('hidden');
    let progressbarWidth = regpriceItemsNumber < 12 ? `${(regpriceItemsNumber / 12) * 100}%` : '100%';
    $('.js-regprice-progressbar').css('width', progressbarWidth)
  }
  else {
    $('.js-cart-header').removeClass('regprice');
    $('.js-cart-regprice').addClass('hidden');
    $('.js-regprice-progressbar').css('width', '0');
  }
  if(regpriceItemsNumber >= 6 && regpriceItemsNumber < 12){
    $('.js-regprice-first-line').removeClass('hidden');
    $('.js-regprice-first-line').html('You have reached <b>6%</b> discount OFF!');
    if(checkProductType !== 'Accessories') {
      $('.js-regprice-second-line').html('Add ' +
      '<b class="js-regprice-num-second">${12 - regpriceItemsNumber}</b> ' +
      'more bottles to get <b>Extra 12%</b> OFF');
    } else {
      $('.js-regprice-second-line').html('Add ' +
      '<b class="js-regprice-num-second">${12 - regpriceItemsNumber}</b> ' +
      'more items to get <b>Extra 12%</b> OFF');
    }
  }
  else if(regpriceItemsNumber >= 12){
    $('.js-regprice-first-line').addClass('hidden');
    $('.js-regprice-second-line').html('You have reached <b>12%</b> OFF');
  }
  else {
    if(checkProductType !== 'Accessories') {
      $('.js-regprice-first-line').html('Add ' +
      '<b class="js-regprice-num-first">${6 - regpriceItemsNumber}</b> ' +
      'more bottles to get <b>Extra 6%</b> OFF');
      $('.js-regprice-second-line').html('or add ' +
          '<b class="js-regprice-num-second">${12 - regpriceItemsNumber}</b> ' +
          'more bottles to get <b>Extra 12%</b> OFF');
    } else {
      $('.js-regprice-first-line').html('Add ' +
      '<b class="js-regprice-num-first">${6 - regpriceItemsNumber}</b> ' +
      'more items to get <b>Extra 6%</b> OFF');
      $('.js-regprice-second-line').html('or add ' +
          '<b class="js-regprice-num-second">${12 - regpriceItemsNumber}</b> ' +
          'more items to get <b>Extra 12%</b> OFF');
    }
    $('.js-regprice-first-line').removeClass('hidden');
  }
  $('.js-regprice-num-first').text(6 - regpriceItemsNumber);
  $('.js-regprice-num-second').text(12 - regpriceItemsNumber);

}

function updatePdpPrice(cartItems, regpriceItemsNumber){
  if(regpriceItemsNumber >= 6 ){
    let currentPrice = parseFloat($('.js-regprice-pdp').siblings('.money').text().substr(1));
    console.log(currentPrice);
    let discountPrice;
    if(regpriceItemsNumber < 12) {
      discountPrice = (currentPrice - (currentPrice * 0.06)).toFixed(2);
    }
    if(regpriceItemsNumber >= 12){
      discountPrice = (currentPrice - (currentPrice * 0.12)).toFixed(2);
    }
    $('.js-regprice-pdp').text(`$${discountPrice}`);
    $(`.js-regprice-pdp`).siblings('.money').css('text-decoration', 'line-through');
    console.log(discountPrice);
  //  $('.js-regprice-pdp').siblings('.money').text()
  }
  else {
       $(`.js-regprice-pdp`).text('');
       $(`.js-regprice-pdp`).siblings('.money').css('text-decoration', 'none');
  }
}

function updateCartDrawerBoldSavings(){
  console.log($('#CartDrawer .bold_csp_qb_savings').length);
  setTimeout(function (){
    if($('#CartDrawer .bold_csp_qb_savings').text().trim().length > 0){
      $('#CartDrawer .bold_csp_qb_savings').removeClass('transparent');
    }
    else {
      $('#CartDrawer .bold_csp_qb_savings').addClass('transparent');
    }
  }, 100);
}